var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/*! For license information please see index.window.js.LICENSE.txt */
/*! twilio-taskrouter.js 0.5.13 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.TaskRouter = t() : e.TaskRouter = t();
}(self, function () {
  return function () {
    var e = {
        142: function _(e, t, r) {
          "use strict";

          r.d(t, {
            M0: function M0() {
              return i;
            },
            in: function _in() {
              return s;
            },
            j3: function j3() {
              return n;
            },
            hO: function hO() {
              return o;
            },
            O: function O() {
              return a;
            },
            iz: function iz() {
              return d;
            },
            nB: function nB() {
              return c;
            },
            FB: function FB() {
              return h;
            },
            Uf: function Uf() {
              return l;
            },
            iR: function iR() {
              return u;
            },
            UA: function UA() {
              return p;
            },
            xf: function xf() {
              return g;
            },
            EA: function EA() {
              return _;
            },
            qG: function qG() {
              return k;
            },
            VH: function VH() {
              return f;
            },
            Qh: function Qh() {
              return w;
            },
            Nt: function Nt() {
              return v;
            },
            L3: function L3() {
              return m;
            },
            zb: function zb() {
              return E;
            },
            fc: function fc() {
              return S;
            },
            PQ: function PQ() {
              return y;
            },
            _G: function _G() {
              return T;
            },
            l4: function l4() {
              return b;
            },
            x6: function x6() {
              return R;
            },
            F3: function F3() {
              return A;
            },
            L8: function L8() {
              return W;
            },
            jz: function jz() {
              return q;
            },
            Iv: function Iv() {
              return C;
            },
            Gf: function Gf() {
              return x;
            }
          });
          var i = "accepted",
            s = "completed",
            n = "rejected",
            o = "wrapping",
            a = "call",
            d = "dequeue",
            c = "redirect",
            h = "conference",
            l = Object.freeze({
              canceled: "canceled",
              complete: "complete",
              failed: "failed",
              initiated: "initiated"
            }),
            u = {
              activitySid: "WorkerActivitySid"
            };
          Object.freeze(u);
          var p = {
            rejectPendingReservations: "RejectPendingReservations"
          };
          Object.freeze(p);
          var g = {
            accept: "CallAccept",
            record: "CallRecord",
            statusCallbackUrl: "CallStatusCallbackUrl",
            timeout: "CallTimeout",
            to: "CallTo"
          };
          Object.freeze(g);
          var _ = {
            to: "DequeueTo",
            from: "DequeueFrom",
            postWorkActivitySid: "DequeuePostWorkActivitySid",
            record: "DequeueRecord",
            timeout: "DequeueTimeout",
            statusCallbackUrl: "DequeueStatusCallbackUrl",
            statusCallbackEvents: "DequeueStatusCallbackEvents"
          };
          Object.freeze(_);
          var k = {
            accept: "RedirectAccept"
          };
          Object.freeze(k);
          var f = {
              taskChannelUniqueName: "TaskChannelUniqueName",
              taskChannelSid: "TaskChannelSid",
              attributes: "Attributes"
            },
            w = "completed",
            v = "wrapping";
          Object.freeze({
            accepted: 0,
            rejected: 1,
            timeout: 2,
            canceled: 3,
            rescinded: 4,
            completed: 5,
            wrapup: 6
          });
          var m = {
            "task.updated": "updated",
            "task.canceled": "canceled",
            "task.completed": "completed",
            "task.wrapup": "wrapup"
          };
          Object.freeze(m);
          var E = {
            "reservation.completed": "completed",
            "reservation.rejected": "rejected",
            "reservation.timeout": "timeout",
            "reservation.canceled": "canceled",
            "reservation.rescinded": "rescinded",
            "reservation.accepted": "accepted",
            "reservation.wrapup": "wrapup"
          };
          Object.freeze(E);
          var S = Object.freeze({
              taskTransfer: "task_transfer",
              activeOutgoingTaskTransfer: "active_outgoing_task_transfer"
            }),
            y = "transfer-initiated",
            T = {
              "transfer-attempt-failed": "attemptFailed",
              "transfer-completed": "completed",
              "transfer-failed": "failed",
              "transfer-initiated": "transferInitiated",
              "transfer-canceled": "canceled"
            };
          Object.freeze(T);
          var b = {
            "task.transfer-attempt-failed": "transfer-attempt-failed",
            "task.transfer-completed": "transfer-completed",
            "task.transfer-failed": "transfer-failed",
            "task.transfer-initiated": "transfer-initiated",
            "task.transfer-canceled": "transfer-canceled"
          };
          Object.freeze(b);
          var R = "v1",
            A = "v2",
            W = 1e3,
            q = 5e3,
            C = {
              TOKEN: "token",
              CLOSE_EXISTING_SESSIONS: "closeExistingSessions",
              CLIENT_VERSION: "clientVersion"
            },
            O = r(830),
            x = [{
              name: "INVALID_ARGUMENT",
              message: "One or more arguments passed were invalid."
            }, {
              name: "INVALID_TOKEN",
              message: "The token is invalid or malformed."
            }, {
              name: "TOKEN_EXPIRED",
              message: "Worker's active token has expired."
            }, {
              name: "GATEWAY_CONNECTION_FAILED",
              message: "Could not connect to Twilio's servers."
            }, {
              name: "GATEWAY_DISCONNECTED",
              message: "Connection to Twilio's servers was lost."
            }, {
              name: "INVALID_GATEWAY_MESSAGE",
              message: "The JSON message received was malformed."
            }, {
              name: "TASKROUTER_ERROR",
              message: "TaskRouter failed to complete the request."
            }].reduce(function (e, t) {
              return e[t.name] = new O(t), e;
            }, {});
        },
        813: function _(e, t) {
          function r(e) {
            if (!(this instanceof r)) return new r(e);
            e = e || {};
            var t = function t() {},
              i = {
                interval: 10,
                now: function now() {
                  return new Date().getTime();
                },
                repeat: function repeat(e, t) {
                  return setInterval(e, t);
                },
                stop: function stop(e, t) {
                  return clearInterval(e, t);
                },
                onsleep: t,
                onwakeup: t
              };
            for (var _t in i) _t in e || (e[_t] = i[_t]);
            this.interval = e.interval, this.lastbeat = 0, this.pintvl = null, this.onsleep = e.onsleep, this.onwakeup = e.onwakeup, this.repeat = e.repeat, this.stop = e.stop, this.now = e.now;
          }
          r.toString = function () {
            return "[Twilio.Heartbeat class]";
          }, r.prototype.toString = function () {
            return "[Twilio.Heartbeat instance]";
          }, r.prototype.beat = function () {
            if (this.lastbeat = this.now(), this.sleeping()) {
              this.onwakeup && this.onwakeup();
              var e = this;
              this.pintvl = this.repeat.call(null, function () {
                e.check();
              }, 1e3 * this.interval);
            }
          }, r.prototype.check = function () {
            var e = this.now() - this.lastbeat;
            !this.sleeping() && e >= 1e3 * this.interval && (this.onsleep && this.onsleep(), this.stop.call(null, this.pintvl), this.pintvl = null);
          }, r.prototype.sleeping = function () {
            return null === this.pintvl;
          }, t.y = r;
        },
        442: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            default: function _default() {
              return s;
            }
          });
          var i = r(142).Gf;
          var s = /*#__PURE__*/function () {
            function s(e, t, r) {
              _classCallCheck(this, s);
              if (!e) throw i.INVALID_ARGUMENT.clone("Error instantiating Paginator. <Array>items is a required parameter.");
              if (!t) throw i.INVALID_ARGUMENT.clone("Error instantiating Paginator. <Function>source is a required parameter.");
              this._nextToken = r, this._source = t, this.hasNextPage = !!this._nextToken, this.items = e;
            }
            _createClass(s, [{
              key: "nextPage",
              value: function nextPage() {
                return this.hasNextPage ? this._source(this._nextToken) : Promise.reject(i.TASKROUTER_ERROR.clone("Error getting the next page. No next page exists."));
              }
            }]);
            return s;
          }();
        },
        834: function _(e, t, r) {
          "use strict";

          function i(e) {
            try {
              return new Date(e);
            } catch (e) {
              return null;
            }
          }
          function s(e, t) {
            for (var _r in e) if (_r in t && !t[_r](e[_r])) throw new TypeError("Option key: ".concat(_r, " does not meet the required type."));
            return !0;
          }
          r.d(t, {
            T: function T() {
              return i;
            },
            n: function n() {
              return s;
            }
          });
        },
        830: function _(e, t, r) {
          function i(e, t) {
            Object.defineProperties(this, {
              _errorData: {
                value: e
              },
              name: {
                value: e.name
              },
              message: {
                value: t || e.message
              }
            });
          }
          (0, r(464).inherits)(i, Error), i.prototype.clone = function (e) {
            return new i(this._errorData, e);
          }, e.exports = i;
        },
        347: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            Supervisor: function Supervisor() {
              return Ce;
            },
            TaskRouterEventHandler: function TaskRouterEventHandler() {
              return be;
            },
            Worker: function Worker() {
              return qe;
            },
            Workspace: function Workspace() {
              return Ne;
            }
          });
          var i = require("lodash");
          var s = r.n(i);
          var n = r(142).Gf,
            o = r(622),
            a = ["trace", "debug", "info", "warn", "error", "silent"];
          var d = /*#__PURE__*/function () {
            function d(e, t) {
              _classCallCheck(this, d);
              if (!e) throw n.INVALID_ARGUMENT.clone("Error instantiating Logger. <string>moduleName is a required parameter.");
              this._log = o.getLogger(e), a.forEach(function (e) {
                var _this = this;
                this[e] = function () {
                  var _this$_log;
                  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
                    t[_key] = arguments[_key];
                  }
                  return (_this$_log = _this._log)[e].apply(_this$_log, [_this._getTimestamp()].concat(t));
                };
              }.bind(this)), t && this.setLevel(t);
            }
            _createClass(d, [{
              key: "setLevel",
              value: function setLevel(e) {
                if (-1 === a.indexOf(e)) throw n.INVALID_ARGUMENT.clone("Error setting Logger level. <string>level must be one of ['trace', 'debug', 'info', 'warn', 'error', 'silent']");
                this._log.setLevel(e, !1), this._log.setDefaultLevel(e);
              }
            }, {
              key: "getLevel",
              value: function getLevel() {
                return a[this._log.getLevel()];
              }
            }, {
              key: "_getTimestamp",
              value: function _getTimestamp() {
                return "[".concat(new Date().toISOString(), "]");
              }
            }]);
            return d;
          }();
          var c = /*#__PURE__*/function () {
            function c(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck(this, c);
              if (!s().isString(e)) throw new TypeError("Failed to initialize Configuration. <string>token is a required parameter.");
              this.logIdentifier = t.logIdentifier || +new Date(), this._logLevel = t.logLevel || "error", this._log = new d("Configuration-".concat(this.logIdentifier), this._logLevel), this.token = e;
              var r = "";
              t.edge && (r += ".".concat(t.edge)), t.region && (r += ".".concat(t.region)), this.EB_SERVER = "https://event-bridge".concat(r, ".twilio.com/v1/wschannels"), this.WS_SERVER = "wss://event-bridge".concat(r, ".twilio.com/v1/wschannels");
            }
            _createClass(c, [{
              key: "updateToken",
              value: function updateToken(e) {
                if (!s().isString(e)) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
                this.token = e;
              }
            }, {
              key: "getLogIdentifier",
              value: function getLogIdentifier() {
                return this.logIdentifier;
              }
            }]);
            return c;
          }();
          var h = r(142);
          var l = require("events");
          var u = r(813);
          var p = "0.5.13",
            g = r.g.window || r.g,
            _ = g.WebSocket ? g.WebSocket : r(352),
            k = p;
          var f = /*#__PURE__*/function (_l$EventEmitter) {
            _inherits(f, _l$EventEmitter);
            var _super = _createSuper(f);
            function f(e) {
              var _this2;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck(this, f);
              if (_this2 = _super.call(this), !(e && e instanceof qe)) throw h.Gf.INVALID_ARGUMENT.clone("<Worker>worker is a required parameter to construct EventBridgeSignaling.");
              var r = e.getLogger("EventBridgeSignaling-".concat(e.sid));
              if (!s().isNil(t.closeExistingSessions) && !s().isBoolean(t.closeExistingSessions)) throw new TypeError("Invalid type passed for <boolean>closeExistingSessions");
              _this2._heartbeat = null, _this2.webSocket = null, _this2._log = r, _this2._worker = e, _this2.closeExistingSessions = t.closeExistingSessions || !1, _this2._config = e._config, _this2.reconnect = !1, _this2.tokenTimer = null, _this2.setUpWebSocket();
              return _possibleConstructorReturn(_this2);
            }
            _createClass(f, [{
              key: "updateToken",
              value: function updateToken(e) {
                if (!e) throw h.Gf.INVALID_ARGUMENT.clone("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
                this.setTokenExpirationEvent(), this._log.info("Updated token for Worker " + this._worker.sid), this.reconnect = !0, this.webSocket.readyState !== this.webSocket.CLOSING && this.webSocket.readyState !== this.webSocket.CLOSED || this.createWebSocket();
              }
            }, {
              key: "setTokenExpirationEvent",
              value: function setTokenExpirationEvent() {
                var _this3 = this;
                clearTimeout(this.tokenTimer), this.tokenTimer = setTimeout(function () {
                  _this3.reconnect = !1, _this3.emit("tokenExpired");
                }, this.tokenLifetime - 5e3);
              }
            }, {
              key: "setUpWebSocket",
              value: function setUpWebSocket() {
                this._heartbeat && (this._heartbeat.onsleep = function () {}), this._heartbeat = new u.y({
                  interval: 60
                }), this.createWebSocket();
              }
            }, {
              key: "setLifetime",
              value: function setLifetime(e) {
                this.tokenLifetime = e, this.setTokenExpirationEvent();
              }
            }, {
              key: "createWebSocket",
              value: function createWebSocket() {
                var _this4 = this;
                this.numAttempts = 1, this.reconnect = !0;
                var e = "?".concat(h.Iv.TOKEN, "=").concat(this._config.token, "&").concat(h.Iv.CLOSE_EXISTING_SESSIONS, "=").concat(this.closeExistingSessions, "&").concat(h.Iv.CLIENT_VERSION, "=").concat(k);
                this.webSocket = new _(this._config.WS_SERVER + e), this.webSocket.onopen = function () {
                  _this4.numAttempts = 1, _this4.emit("connected"), _this4._heartbeat.onsleep = function () {
                    _this4._log.info("Heartbeat not received in the past 60 seconds. Proceeding to disconnect websocket."), _this4.webSocket.close();
                  }, _this4._heartbeat.beat();
                }, this.webSocket.onmessage = function (e) {
                  if (_this4._log.debug("Received event", e.data), _this4._heartbeat.beat(), 0 === e.data.trim().length) return;
                  var t;
                  try {
                    t = JSON.parse(e.data);
                  } catch (t) {
                    return _this4._log.error("Received data is not valid JSON: " + e.data), void _this4.emit("error", h.Gf.INVALID_GATEWAY_MESSAGE);
                  }
                  _this4._log.debug("Emitting event: %s with %s", t.event_type, JSON.stringify(t.payload)), _this4.emit(t.event_type, t.payload || null, t.event_type);
                }, this.webSocket.onerror = function (e) {
                  _this4._log.error("WebSocket error occurred: ", e), _this4.emit("error", h.Gf.GATEWAY_CONNECTION_FAILED);
                }, this.webSocket.onclose = function (e) {
                  _this4.reconnect ? _this4._log.info("WebSocket connection has closed. Trying to reconnect.") : _this4._log.info("WebSocket connection has closed. Not reconnecting due to token expiration.");
                  var t = e.reason;
                  var r = e.code;
                  if (s().isEmpty(t) && (t = "Websocket closed with errorCode=".concat(r)), _this4.emit("disconnected", {
                    message: t
                  }), _this4._heartbeat.onsleep = function () {}, _this4.reconnect) {
                    var _e2 = _this4.generateBackOffInterval(_this4.numAttempts);
                    setTimeout(function () {
                      _this4.numAttempts++, _this4.createWebSocket();
                    }, _e2);
                  }
                };
              }
            }, {
              key: "generateBackOffInterval",
              value: function generateBackOffInterval(e) {
                var t = Math.ceil(800),
                  r = Math.floor(1e3 * Math.min(30, Math.pow(2, e) - 1));
                return Math.round(Math.floor(Math.random() * (r - t + 1)) + t);
              }
            }, {
              key: "disconnect",
              value: function disconnect() {
                var _this5 = this;
                this._log.info("Disconnecting websocket"), null !== this.webSocket && (["onmessage", "onclose", "onopen", "onerror"].forEach(function (e) {
                  _this5.webSocket[e] = null;
                }), this._heartbeat.onsleep = function () {}, this.webSocket.close()), this.emit("disconnected", {
                  message: "SDK Disconnect"
                });
              }
            }]);
            return f;
          }(l.EventEmitter);
          var w = require("axios");
          var v = r(997);
          var m = {
            GET: "GET",
            POST: "POST"
          };
          Object.freeze(m);
          var E = p;
          var S = /*#__PURE__*/function () {
            function S(e) {
              _classCallCheck(this, S);
              if (!(e instanceof c)) throw new TypeError("Failed to initialize Request. <Configuration>config is a required parameter.");
              var t = new v.Agent({
                maxVersion: "TLSv1.2",
                minVersion: "TLSv1.2"
              });
              this._config = e, this._postClient = w.create({
                method: m.POST,
                timeout: h.jz,
                headers: {
                  clientVersion: E
                },
                httpsAgent: t
              });
            }
            _createClass(S, [{
              key: "post",
              value: function post(e, t, r) {
                if (!e) throw new Error("Failed to make POST request. <string>url is a required parameter.");
                if (!s().isObject(t)) throw new Error("Failed to make POST request. <object>paramsJSON is a required parameter.");
                if (!r) throw new Error("Failed to make POST request. <string>apiVersion is a required parameter.");
                var i = this.buildRequest(m.POST, e, t);
                return this._postClient.post(this._config.EB_SERVER, i, {
                  headers: {
                    apiVersion: r
                  }
                }).then(function (e) {
                  return Promise.resolve(e.data.payload);
                });
              }
            }, {
              key: "get",
              value: function get(e, t, r) {
                if (!e) throw new Error("Failed to make GET request. <string>url is a required parameter.");
                if (!t) throw new Error("Failed to make GET request. <string>apiVersion is a required parameter.");
                if (r = r || {}, !s().isObject(r)) throw new Error("Failed to make GET request. <object>paramsJSON is a required parameter.");
                var i = this.buildRequest(m.GET, e, r);
                return this._postClient.post(this._config.EB_SERVER, i, {
                  headers: {
                    apiVersion: t
                  }
                }).then(function (e) {
                  return Promise.resolve(e.data.payload);
                });
              }
            }, {
              key: "buildRequest",
              value: function buildRequest(e, t, r) {
                return JSON.stringify({
                  url: t,
                  method: e,
                  params: r,
                  token: this._config.token
                });
              }
            }]);
            return S;
          }();
          var y = r(470),
            T = r.n(y);
          var b = r(142).Gf,
            R = "reservationList",
            A = "reservationInstance",
            W = "workerInstance",
            q = "workerList",
            C = "taskReservationInstance",
            O = "taskList",
            x = "taskInstance",
            F = "taskTransferList",
            j = "taskTransferInstance",
            D = "taskQueueList",
            U = "workerChannels",
            P = "activitiesList",
            N = "customerParticipantInstance",
            $ = "workerParticipantInstance",
            I = "holdWorkerParticipantInstance",
            L = "kickWorkerParticipant";
          var z = /*#__PURE__*/function () {
            function z(e, t) {
              var _this$routes;
              _classCallCheck(this, z);
              if (!e || !t) throw b.INVALID_ARGUMENT.clone("Error instantiating Routes class. <string>workspaceSid and <string>workerSid are required parameters.");
              this.workspaceSid = e, this.workerSid = t, this.routes = (_this$routes = {}, _defineProperty(_this$routes, P, {
                path: T().join("Workspaces", this.workspaceSid, "Activities")
              }), _defineProperty(_this$routes, W, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid)
              }), _defineProperty(_this$routes, q, {
                path: T().join("Workspaces", this.workspaceSid, "Workers")
              }), _defineProperty(_this$routes, A, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Reservations", "%s")
              }), _defineProperty(_this$routes, R, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Reservations")
              }), _defineProperty(_this$routes, O, {
                path: T().join("Workspaces", this.workspaceSid, "Tasks")
              }), _defineProperty(_this$routes, x, {
                path: T().join("Workspaces", this.workspaceSid, "Tasks", "%s")
              }), _defineProperty(_this$routes, F, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Transfers")
              }), _defineProperty(_this$routes, j, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Transfers", "%s")
              }), _defineProperty(_this$routes, C, {
                path: T().join("Workspaces", this.workspaceSid, "Tasks", "%s", "Reservations", "%s")
              }), _defineProperty(_this$routes, D, {
                path: T().join("Workspaces", this.workspaceSid, "TaskQueues")
              }), _defineProperty(_this$routes, U, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "WorkerChannels")
              }), _defineProperty(_this$routes, N, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "CustomerParticipant")
              }), _defineProperty(_this$routes, $, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "WorkerParticipant")
              }), _defineProperty(_this$routes, I, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "HoldWorkerParticipant")
              }), _defineProperty(_this$routes, L, {
                path: T().join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "KickWorkerParticipant")
              }), _this$routes);
            }
            _createClass(z, [{
              key: "getRoute",
              value: function getRoute(e) {
                if (!this.routes[e]) throw b.INVALID_ARGUMENT.clone("Invalid route fetched <string>route \"".concat(e, "\" does not exist."));
                for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  t[_key2 - 1] = arguments[_key2];
                }
                if (t.length) {
                  var _r2 = Object.assign({}, this.routes[e]);
                  if (t.length !== (_r2.path.match(/%s/g) || []).length) throw b.INVALID_ARGUMENT.clone("Invalid number of positional arguments supplied for route ".concat(e));
                  var _iterator = _createForOfIteratorHelper(t),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var _e3 = _step.value;
                      _r2.path = _r2.path.replace(/%s/, _e3);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  return _r2;
                }
                return this.routes[e];
              }
            }]);
            return z;
          }();
          var H = r(834);
          var M = /*#__PURE__*/_createClass(function M(e, t) {
            _classCallCheck(this, M);
            if (!s().isObject(e)) throw new TypeError("Failed to create a WorkerDescriptor. <Descriptor>descriptor is a required parameter.");
            if (!s().isObject(t)) throw new TypeError("Failed to create a WorkerDescriptor. <Configuration>config is a required parameter.");
            if (!We.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to create a WorkerDescriptor. The provided <Descriptor>descriptor does not contain all properties of a Worker.");
            this.accountSid = e.account_sid, this.activityName = e.activity_name, this.activitySid = e.activity_sid, this.attributes = JSON.parse(e.attributes), this.available = e.available, this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateStatusChanged = (0, H.T)(1e3 * e.date_status_changed), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.name = e.friendly_name, this.sid = e.sid, this.workspaceSid = e.workspace_sid;
          });
          var B = /*#__PURE__*/_createClass(function B(e) {
            _classCallCheck(this, B);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate ActivityDescriptor. <Descriptor>descriptor is required.");
            if (!Q.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to instantiate ActivityDescriptor. <Descriptor>descriptor does not contain all properties of an Activity.");
            this.accountSid = e.account_sid, this.available = e.available, this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.name = e.friendly_name, this.sid = e.sid, this.workspaceSid = e.workspace_sid;
          });
          var G = r(834).n;
          var Q = ["account_sid", "available", "date_created", "date_updated", "friendly_name", "sid", "workspace_sid"],
            V = /*#__PURE__*/function () {
              function V(e, t) {
                _classCallCheck(this, V);
                if (!s().isObject(e)) throw new TypeError("Failed to create an Activity. <Worker>worker is a required parameter.");
                if (!(t instanceof B)) throw new TypeError("Failed to create an Activity. <ActivityDescriptor>descriptor is a required parameter.");
                Object.assign(this, t), this._worker = e, this._isCurrent = !1;
              }
              _createClass(V, [{
                key: "isCurrent",
                get: function get() {
                  return this._isCurrent;
                }
              }, {
                key: "setAsCurrent",
                value: function setAsCurrent() {
                  var _this6 = this;
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  if (!G(e, {
                    rejectPendingReservations: function rejectPendingReservations(e) {
                      return s().isBoolean(e);
                    }
                  })) throw new TypeError("Failed to set activity=".concat(this.sid, ". The options passed in did not match the required types."));
                  if (e.rejectPendingReservations && this.available) throw new Error("Unable to reject pending reservations when updating to an Available activity state.");
                  return this._worker._updateWorkerActivity(this.sid, e).then(function () {
                    return _this6;
                  });
                }
              }]);
              return V;
            }();
          var J = r(442);
          var K = /*#__PURE__*/function () {
            function K(e, t) {
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _classCallCheck(this, K);
              if (!s().isObject(e)) throw new TypeError("Failed to initialize ActivitiesEntity. <Worker>worker is a required parameter.");
              this._activities = new Map(), this._log = e.getLogger("ActivitiesEntity-".concat(e.sid)), this._request = t, this._worker = e, this._pageSize = r.pageSize || h.L8, s().inRange(this._pageSize, 1, h.L8 + 1) || (this._log.warn("PageSize range for ActivitiesEntity must be between 1 and %d. Setting pageSize to default size=%d", h.L8, h.L8), this._pageSize = 1e3);
            }
            _createClass(K, [{
              key: "activities",
              get: function get() {
                return this._activities;
              }
            }, {
              key: "fetchActivities",
              value: function fetchActivities() {
                var e = this._getPage();
                return this._getAllActivities(e);
              }
            }, {
              key: "_getAllActivities",
              value: function _getAllActivities(e) {
                var _this7 = this;
                return e.then(function (e) {
                  return e.items.forEach(function (e) {
                    _this7._insertActivity(e);
                  }), e.hasNextPage ? _this7._getAllActivities(e.nextPage()) : Promise.resolve();
                });
              }
            }, {
              key: "_getPage",
              value: function _getPage(e) {
                var _this8 = this;
                e = e || {};
                var t = this._worker.getRoutes().getRoute(P).path,
                  r = {
                    PageSize: this._pageSize
                  };
                return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, h.x6, r).then(function (e) {
                  return new J.default(e.contents.map(function (e) {
                    return new B(e);
                  }), function (e) {
                    return _this8._getPage({
                      AfterSid: e
                    });
                  }, e.after_sid);
                });
              }
            }, {
              key: "_insertActivity",
              value: function _insertActivity(e) {
                var t = e.sid;
                this._log.trace("_insertActivity(sid=".concat(t, ", data=").concat(JSON.stringify(e)));
                try {
                  var _r3 = new V(this._worker, e);
                  this._activities.set(t, _r3);
                } catch (e) {
                  this._log.error("Unable to create an Activity for sid=".concat(t, ". Skipping insert into Activities map. Error: ").concat(e));
                }
              }
            }]);
            return K;
          }();
          var Y = /*#__PURE__*/_createClass(function Y(e) {
            _classCallCheck(this, Y);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate WorkerChannelDescriptor. <Descriptor>descriptor is required.");
            if (!ee.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to create a WorkerChannelDescriptor. <Descriptor>descriptor does not contain all properties of a Channel.");
            this.accountSid = e.account_sid, this.assignedTasks = e.assigned_tasks, this.available = !!e.available, this.availableCapacityPercentage = e.available_capacity_percentage, this.capacity = e.configured_capacity, this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.lastReservedTime = (0, H.T)(e.last_reserved_time), this.sid = e.sid, this.taskChannelSid = e.task_channel_sid, this.taskChannelUniqueName = e.task_channel_unique_name, this.workerSid = e.worker_sid, this.workspaceSid = e.workspace_sid;
          });
          var X = ["capacity", "available", "assignedTasks", "availableCapacityPercentage", "dateUpdated", "lastReservedTime"];
          var Z = /*#__PURE__*/function (_l$EventEmitter2) {
            _inherits(Z, _l$EventEmitter2);
            var _super2 = _createSuper(Z);
            function Z(e, t, r) {
              var _this9;
              _classCallCheck(this, Z);
              if (_this9 = _super2.call(this), !(e instanceof qe)) throw new TypeError("Failed to instantiate Worker. <Worker>worker is a required parameter.");
              if (!(r instanceof Y)) throw new TypeError("Failed to instantiate Channel. <WorkerChannelDescriptor>descriptor is a required parameter.");
              _this9._request = t, _this9._log = e.getLogger("Channel-".concat(r.sid)), Object.assign(_assertThisInitialized(_this9), r);
              return _possibleConstructorReturn(_this9);
            }
            _createClass(Z, [{
              key: "_emitEvent",
              value: function _emitEvent(e, t) {
                if (!s().isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
                if (!s().isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>rawEventData is a required parameter.");
                this._update(t), this.emit(e, this);
              }
            }, {
              key: "_update",
              value: function _update(e) {
                var _this10 = this;
                try {
                  var _t2 = new Y(e);
                  X.forEach(function (e) {
                    _this10[e] = _t2[e];
                  });
                } catch (t) {
                  this._log.warn("Failed to update Channel sid=%s. Update aborted. Error: %s.", e.sid, t);
                }
                return this;
              }
            }]);
            return Z;
          }(l.EventEmitter);
          var ee = ["account_sid", "assigned_tasks", "available", "available_capacity_percentage", "configured_capacity", "date_created", "date_updated", "last_reserved_time", "sid", "task_channel_sid", "task_channel_unique_name", "worker_sid", "workspace_sid"],
            te = Z;
          var re = /*#__PURE__*/function () {
            function re(e, t) {
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _classCallCheck(this, re);
              if (!(e instanceof qe)) throw new TypeError("Failed to initialize ChannelsEntity. <Worker>worker is a required parameter.");
              this._channels = new Map(), this._log = e.getLogger("ChannelsEntity"), this._request = t, this._pageSize = r.pageSize || h.L8, this._worker = e, s().inRange(this._pageSize, 1, h.L8 + 1) || (this._log.warn("PageSize range for ChannelsEntity must be between 1 and %d. Setting pageSize to default size=%d", h.L8, h.L8), this._pageSize = 1e3);
            }
            _createClass(re, [{
              key: "channels",
              get: function get() {
                return this._channels;
              }
            }, {
              key: "fetchChannels",
              value: function fetchChannels() {
                var e = this._getPage();
                return this._getAllChannels(e);
              }
            }, {
              key: "_getAllChannels",
              value: function _getAllChannels(e) {
                var _this11 = this;
                return e.then(function (e) {
                  return e.items.forEach(function (e) {
                    _this11._insertChannel(e);
                  }), e.hasNextPage ? _this11._getAllChannels(e.nextPage()) : Promise.resolve();
                });
              }
            }, {
              key: "_getPage",
              value: function _getPage(e) {
                var _this12 = this;
                e = e || {};
                var t = this._worker.getRoutes().getRoute(U).path,
                  r = {
                    PageSize: this._pageSize
                  };
                return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, h.x6, r).then(function (e) {
                  return new J.default(e.contents.map(function (e) {
                    return new Y(e);
                  }), function (e) {
                    return _this12._getPage({
                      AfterSid: e
                    });
                  }, e.after_sid);
                });
              }
            }, {
              key: "_insertChannel",
              value: function _insertChannel(e) {
                var t = e.sid;
                this._log.trace("_insertChannel(sid=".concat(t, ", data=").concat(JSON.stringify(e)));
                try {
                  var _r4 = new te(this._worker, this._request, e);
                  this._channels.set(t, _r4);
                } catch (e) {
                  this._log.error("Unable to create a Channel for sid=".concat(t, ". Skipping insert into Channels map. Error: ").concat(e));
                }
              }
            }]);
            return re;
          }();
          var ie = /*#__PURE__*/_createClass(function ie(e) {
            _classCallCheck(this, ie);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate TransferDescriptor. <Descriptor>descriptor is required.");
            if (!oe.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to instantiate TransferDescriptor. <Descriptor>descriptor does not contain all properties of a Transfer.");
            this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.mode = e.transfer_mode, this.queueSid = e.initiating_queue_sid, this.reservationSid = e.initiating_reservation_sid, this.to = e.transfer_to, this.transferFailedReason = e.transfer_failed_reason, this.type = e.transfer_type, this.sid = e.sid, this.status = e.transfer_status, this.workerSid = e.initiating_worker_sid, this.workflowSid = e.initiating_workflow_sid;
          });
          var se = ["dateUpdated", "status", "transferFailedReason"];
          var ne = /*#__PURE__*/function (_l$EventEmitter3) {
            _inherits(ne, _l$EventEmitter3);
            var _super3 = _createSuper(ne);
            function ne(e, t) {
              var _this13;
              _classCallCheck(this, ne);
              if (_this13 = _super3.call(this), !(t instanceof ie)) throw new TypeError("Failed to instantiate Transfer. <TransferDescriptor>descriptor is a required parameter.");
              _this13._log = e.getLogger("Transfer-".concat(t.sid)), Object.assign(_assertThisInitialized(_this13), t);
              return _possibleConstructorReturn(_this13);
            }
            _createClass(ne, [{
              key: "_update",
              value: function _update(e) {
                var _this14 = this;
                try {
                  var _t3 = new ie(e);
                  se.forEach(function (e) {
                    _this14[e] = _t3[e];
                  });
                } catch (t) {
                  throw this._log.error("Failed to update Transfer sid=".concat(e.sid, ". Update aborted."), t), new Error("Failed to update Transfer sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, "."));
                }
                return this;
              }
            }]);
            return ne;
          }(l.EventEmitter);
          var oe = ["date_created", "date_updated", "initiating_reservation_sid", "initiating_worker_sid", "initiating_queue_sid", "initiating_workflow_sid", "sid", "transfer_mode", "transfer_to", "transfer_type", "transfer_status"],
            ae = ne;
          var de = /*#__PURE__*/function (_ae) {
            _inherits(de, _ae);
            var _super4 = _createSuper(de);
            function de(e, t) {
              _classCallCheck(this, de);
              return _super4.call(this, e, t);
            }
            return _createClass(de);
          }(ae);
          var ce = /*#__PURE__*/function (_ae2) {
            _inherits(ce, _ae2);
            var _super5 = _createSuper(ce);
            function ce(e, t, r, i) {
              var _this15;
              _classCallCheck(this, ce);
              if (_this15 = _super5.call(this, e, i), "string" != typeof r) throw new TypeError("Failed to instantiate OutgoingTransfer. <string>taskSid is a required parameter.");
              _this15._worker = e, _this15._request = t, _this15.taskSid = r;
              return _possibleConstructorReturn(_this15);
            }
            _createClass(ce, [{
              key: "_emitEvent",
              value: function _emitEvent(e, t) {
                if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !s().isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
                if (!s().isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
                this.emit(e, this);
              }
            }, {
              key: "cancel",
              value: function () {
                var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var e, t, r;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        e = this._worker.getRoutes().getRoute(j, this.sid).path;
                        t = {
                          TaskSid: this.taskSid,
                          TransferStatus: h.Uf.canceled
                        };
                        _context.next = 4;
                        return this._request.post(e, t, h.F3);
                      case 4:
                        r = _context.sent;
                        return _context.abrupt("return", this._update(r));
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, this);
                }));
                function cancel() {
                  return _cancel.apply(this, arguments);
                }
                return cancel;
              }()
            }]);
            return ce;
          }(ae);
          var he = /*#__PURE__*/function (_l$EventEmitter4) {
            _inherits(he, _l$EventEmitter4);
            var _super6 = _createSuper(he);
            function he(e, t, r) {
              var _this16;
              _classCallCheck(this, he);
              if (_this16 = _super6.call(this), !(r instanceof ke)) throw new TypeError("Failed to instantiate Transfers. <TaskDescriptor>taskDescriptor is a required parameter.");
              _this16._log = e.getLogger("Transfers-".concat(r.sid)), _this16._worker = e, _this16._request = t, _this16.incoming = r.incomingTransferDescriptor ? new de(e, r.incomingTransferDescriptor) : null, _this16.outgoing = r.outgoingTransferDescriptor ? new ce(e, t, r.sid, r.outgoingTransferDescriptor) : null;
              return _possibleConstructorReturn(_this16);
            }
            _createClass(he, [{
              key: "_emitEvent",
              value: function _emitEvent(e, t) {
                if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !s().isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
                if (!s().isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
                var r = h._G[e];
                this.outgoing ? this.outgoing.sid === t.sid ? Object.keys(s().pick(h._G, ["transfer-attempt-failed", "transfer-completed", "transfer-failed", "transfer-canceled"])).indexOf(e) > -1 && (this._updateOutgoing(t), this.outgoing._emitEvent(r, t)) : this._log.warn("The transfer %s specified by Event: transfer.%s does not match the current active outgoing transfer for Worker %s. Skipping event.", t.sid, r, this._worker.sid) : this._log.warn("An active outgoing transfer does currently exist in Worker %s transfers map for Event: transfer.%s. Skipping event.", this._worker.sid, r);
              }
            }, {
              key: "_updateOutgoing",
              value: function _updateOutgoing(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                !this.outgoing || t ? this.outgoing = new ce(this._worker, this._request, e.task_sid, new ie(e)) : this.outgoing._update(e);
              }
            }, {
              key: "_update",
              value: function _update(e) {
                if (e.incoming) if (this.incoming) this.incoming._update(e.incoming);else {
                  var _t4 = new ie(e.incoming);
                  this.incoming = new de(this._worker, this._request, e.incoming.task_sid, _t4);
                }
                if (e.outgoing) if (this.outgoing) this.outgoing._update(e.outgoing);else {
                  var _t5 = new ie(e.outgoing);
                  this.outgoing = new ce(this._worker, this._request, e.outgoing.task_sid, _t5);
                }
              }
            }]);
            return he;
          }(l.EventEmitter);
          var le = he,
            ue = ["attributes", "status", "workflowSid", "workflowName", "queueSid", "queueName", "priority", "reason", "routingTarget", "timeout", "taskChannelSid", "taskChannelUniqueName", "age", "addOns", "dateUpdated", "transfers"];
          var pe = /*#__PURE__*/function (_l$EventEmitter5) {
            _inherits(pe, _l$EventEmitter5);
            var _super7 = _createSuper(pe);
            function pe(e, t, r, i) {
              var _this17;
              _classCallCheck(this, pe);
              if (_this17 = _super7.call(this), !(e instanceof qe)) throw new TypeError("Failed to instantiate Task. <Worker>worker is a required parameter.");
              if (!i) throw new TypeError("Failed to instantiate Task. <TaskDescriptor>descriptor is a required parameter.");
              if (!(i instanceof ke)) throw new TypeError("descriptor should be of type <TaskDescriptor>");
              if ("string" != typeof r) throw new TypeError("Failed to instantiate Task. <string>reservationSid is a required parameter.");
              _this17._worker = e, _this17._log = e.getLogger("Task-".concat(i.sid)), _this17._request = t, _this17.transfers = new le(e, t, i), Object.assign(_assertThisInitialized(_this17), i), _this17.reservationSid = r;
              return _possibleConstructorReturn(_this17);
            }
            _createClass(pe, [{
              key: "complete",
              value: function complete(e) {
                var _this18 = this;
                if (!s().isString(e)) throw new TypeError("Error calling method complete(). <string>reason is a required parameter.");
                var t = this._worker.getRoutes().getRoute(x, this.sid).path,
                  r = {
                    AssignmentStatus: h.Qh,
                    Reason: e
                  };
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this18._update(e);
                });
              }
            }, {
              key: "transfer",
              value: function () {
                var _transfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
                  var t,
                    r,
                    i,
                    n,
                    _args2 = arguments;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        t = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                        if (s().isString(e)) {
                          _context2.next = 3;
                          break;
                        }
                        throw new TypeError("Error calling method transfer(). <string>to is a required parameter.");
                      case 3:
                        r = this._worker.getRoutes().getRoute(F).path, i = {
                          ReservationSid: this.reservationSid,
                          TaskSid: this.sid,
                          To: e
                        };
                        t.attributes && (i.Attributes = t.attributes), t.mode && (i.Mode = t.mode), t.priority && (i.Priority = t.priority);
                        _context2.next = 7;
                        return this._request.post(r, i, h.F3);
                      case 7:
                        n = _context2.sent;
                        return _context2.abrupt("return", (this._log.info("Received response to transfer request to Worker/TaskQueue=".concat(e)), this._log.debug("Response object", n), this.transfers._updateOutgoing(n, !0), this));
                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, this);
                }));
                function transfer(_x) {
                  return _transfer.apply(this, arguments);
                }
                return transfer;
              }()
            }, {
              key: "wrapUp",
              value: function wrapUp() {
                var _this19 = this;
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var t = this._worker.getRoutes().getRoute(x, this.sid).path,
                  r = {
                    AssignmentStatus: h.Nt
                  };
                if (e.reason) {
                  if (!s().isString(e.reason)) throw new Error("Failed to call wrapUp() on Task sid=".concat(this.sid, ". A <string>reason is required."));
                  r.Reason = e.reason;
                }
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this19._update(e);
                });
              }
            }, {
              key: "setAttributes",
              value: function setAttributes(e) {
                var _this20 = this;
                if (!s().isObject(e)) throw new TypeError("Unable to set attributes on Task. <object>attributes is a required parameter.");
                var t = this._worker.getRoutes().getRoute(x, this.sid).path,
                  r = {
                    Attributes: e
                  };
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this20._update(e);
                });
              }
            }, {
              key: "updateParticipant",
              value: function updateParticipant(e) {
                var _this21 = this;
                var t = {
                  hold: function hold(e) {
                    return s().isBoolean(e);
                  },
                  holdUrl: function holdUrl(e) {
                    return s().isString(e);
                  },
                  holdMethod: function holdMethod(e) {
                    return s().isString(e);
                  }
                };
                if (!(0, H.n)(e, t)) throw new TypeError("Failed to update Participant tied to Task sid=".concat(this.sid, ". The options passed in did not match the required types."));
                var r = this._worker.getRoutes().getRoute(N).path,
                  i = {
                    TaskSid: this.sid
                  };
                for (var _t6 in e) i[s().upperFirst(_t6)] = e[_t6];
                return this._request.post(r, i, h.F3).then(function (e) {
                  return _this21._update(e);
                });
              }
            }, {
              key: "kick",
              value: function kick(e) {
                var _this22 = this;
                if (!s().isString(e)) throw new TypeError("Error calling method kick(). <string>workerSid is a required parameter.");
                var t = this._worker.getRoutes().getRoute(L).path,
                  r = {
                    TaskSid: this.sid,
                    TargetWorkerSid: e
                  };
                return this._request.post(t, r, h.F3).then(function (e) {
                  return _this22._update(e);
                });
              }
            }, {
              key: "hold",
              value: function hold(e, t, r) {
                var _this23 = this;
                var i = {
                  holdUrl: function holdUrl(e) {
                    return s().isString(e);
                  },
                  holdMethod: function holdMethod(e) {
                    return s().isString(e);
                  }
                };
                if (!s().isString(e)) throw new TypeError("Error calling method hold(). <string>targetWorkerSid is a required parameter.");
                if (!s().isBoolean(t)) throw new TypeError("Error calling method hold(). <boolean>onHold is a required parameter that is either true or false.");
                if (!(0, H.n)(r, i)) throw new TypeError("Failed to update Participant tied to Task sid=".concat(this.sid, ". The options passed in did not match the required types."));
                var n = this._worker.getRoutes().getRoute(I).path,
                  o = {
                    TaskSid: this.sid,
                    TargetWorkerSid: e,
                    Hold: t
                  };
                for (var _e4 in r) o[s().upperFirst(_e4)] = r[_e4];
                return this._request.post(n, o, h.F3).then(function (e) {
                  return _this23._update(e);
                });
              }
            }, {
              key: "_emitEvent",
              value: function _emitEvent(e, t) {
                if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !s().isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
                if (!s().isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
                this.emit(e, this, t);
              }
            }, {
              key: "_emitEventForOutgoingTransfer",
              value: function () {
                var _emitEventForOutgoingTransfer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, t) {
                  var r;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(this._log.debug("_emitEventForOutgoingTransfer(".concat(e, ", ").concat(JSON.stringify(t), ")")), !s().isString(e))) {
                          _context3.next = 2;
                          break;
                        }
                        throw new TypeError("Error calling _emitEventForOutgoingTransfer(). <string>eventType is a required parameter.");
                      case 2:
                        if (s().isObject(t)) {
                          _context3.next = 4;
                          break;
                        }
                        throw new TypeError("Error calling method _emitEventForOutgoingTransfer(). <object>payload is a required parameter.");
                      case 4:
                        this.transfers.outgoing || this._log.debug("The transfers.outgoing object is NOT present");
                        r = 0;
                      case 6:
                        if (!(!this.transfers.outgoing && r < 20)) {
                          _context3.next = 13;
                          break;
                        }
                        _context3.next = 9;
                        return new Promise(function (e) {
                          return setTimeout(e, 500);
                        });
                      case 9:
                        r++;
                        this._log.debug("Transfer event arrived, waiting for API response, because transfer object missing", r);
                      case 11:
                        _context3.next = 6;
                        break;
                      case 13:
                        r = 0;
                      case 14:
                        if (!(this.transfers.outgoing && this.transfers.outgoing.sid !== t.sid && r < 20)) {
                          _context3.next = 21;
                          break;
                        }
                        _context3.next = 17;
                        return new Promise(function (e) {
                          return setTimeout(e, 500);
                        });
                      case 17:
                        r++;
                        this._log.debug("Transfer event arrived, waiting for API response to get the correct transfer SID", r);
                      case 19:
                        _context3.next = 14;
                        break;
                      case 21:
                        this._log.debug("Transfer sid from API response:", this.transfers && this.transfers.outgoing ? this.transfers.outgoing.sid : "No sid"), this._log.debug("Transfer sid from event:", t.sid), this.transfers.outgoing && this.transfers.outgoing.sid === t.sid ? Object.keys(s().pick(h._G, [h.PQ])).indexOf(e) > -1 ? (this.transfers._updateOutgoing(t), this.emit(h._G[h.PQ], this.transfers.outgoing)) : this.transfers._emitEvent(e, t) : this._log.debug("The transfers.outgoing object is either not present or does not match the transfer sid in the event. ".concat(JSON.stringify(t)));
                      case 22:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, this);
                }));
                function _emitEventForOutgoingTransfer(_x2, _x3) {
                  return _emitEventForOutgoingTransfer2.apply(this, arguments);
                }
                return _emitEventForOutgoingTransfer;
              }()
            }, {
              key: "_update",
              value: function _update(e) {
                var _this24 = this;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                  var _r5 = new ke(e, this._config);
                  ue.forEach(function (e) {
                    "transfers" === e ? (t.incoming || t.outgoing) && _this24.transfers._update(t) : _this24[e] = _r5[e];
                  });
                } catch (t) {
                  throw this._log.error("Failed to update Task sid=".concat(e.sid, ". Update aborted."), t), new Error("Failed to update Task sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, "."));
                }
                return this;
              }
            }]);
            return pe;
          }(l.EventEmitter);
          var ge = ["addons", "age", "attributes", "date_created", "date_updated", "priority", "queue_name", "queue_sid", "reason", "routing_target", "sid", "assignment_status", "task_channel_unique_name", "task_channel_sid", "timeout", "workflow_name", "workflow_sid"],
            _e = pe;
          var ke = /*#__PURE__*/_createClass(function ke(e) {
            _classCallCheck(this, ke);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate TaskDescriptor. <Descriptor>descriptor is required.");
            if (!ge.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to instantiate TaskDescriptor. <Descriptor>descriptor does not contain all properties of a Task.");
            this.addOns = JSON.parse(e.addons), this.age = e.age, this.attributes = JSON.parse(e.attributes), this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.priority = e.priority, this.queueName = e.queue_name, this.queueSid = e.queue_sid, this.reason = e.reason, this.routingTarget = e.routing_target, this.sid = e.sid, this.status = e.assignment_status, this.taskChannelUniqueName = e.task_channel_unique_name, this.taskChannelSid = e.task_channel_sid, this.timeout = e.timeout, this.workflowName = e.workflow_name, this.workflowSid = e.workflow_sid, this.incomingTransferDescriptor = null, this.outgoingTransferDescriptor = null;
          });
          var fe = /*#__PURE__*/_createClass(function fe(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _classCallCheck(this, fe);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate ReservationDescriptor. <Descriptor>descriptor is required.");
            if (!s().isObject(t)) throw new TypeError("Failed to instantiate ReservationDescriptor. <Worker>worker is required.");
            var i = s().filter(Se, function (e) {
              return -1 === r.indexOf(e);
            });
            if (!s().every(i, function (t) {
              return t in e;
            })) {
              var _t7 = s().difference(i, Object.keys(e)).join(", ");
              throw new TypeError("Failed to instantiate ReservationDescriptor. <Descriptor>descriptor does not contain all properties of a Reservation. Missing: ".concat(_t7));
            }
            this.accountSid = e.account_sid, this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated), this.sid = e.sid, this.status = e.reservation_status, this.timeout = e.reservation_timeout, this.workerSid = e.worker_sid, this.workspaceSid = e.workspace_sid, this.taskDescriptor = null, e.canceled_reason_code && (this.canceledReasonCode = e.canceled_reason_code);
            var n = t.getLogger("ReservationDescriptor-".concat(this.sid));
            if (-1 === r.indexOf("task")) try {
              this.taskDescriptor = new ke(e.task);
            } catch (e) {
              throw n.error("Failed to create a ReservationDescriptor. The 'task' property is malformed."), e;
            }
            if (-1 === r.indexOf(h.fc.taskTransfer) && "object" == typeof e.task_transfer) try {
              this.taskDescriptor.incomingTransferDescriptor = new ie(e.task_transfer), this.transferDescriptor = new ie(e.task_transfer);
            } catch (e) {
              throw n.error("Failed to create a ReservationDescriptor. The 'task_transfer' property is malformed."), e;
            }
            if (-1 === r.indexOf(h.fc.activeOutgoingTaskTransfer) && "object" == typeof e.active_outgoing_task_transfer) try {
              this.taskDescriptor.outgoingTransferDescriptor = new ie(e.active_outgoing_task_transfer);
            } catch (e) {
              throw n.error("Failed to create a ReservationDescriptor. The 'active_outgoing_task_transfer' property is malformed."), e;
            }
          });
          var we = r(834).n,
            ve = ["dateUpdated", "canceledReasonCode", "status", "timeout", "task", "task_transfer"],
            me = ["reservation_timeout", "task", "canceled_reason_code"];
          var Ee = /*#__PURE__*/function (_l$EventEmitter6) {
            _inherits(Ee, _l$EventEmitter6);
            var _super8 = _createSuper(Ee);
            function Ee(e, t, r) {
              var _this25;
              _classCallCheck(this, Ee);
              if (_this25 = _super8.call(this), !(e instanceof qe)) throw new TypeError("Failed to instantiate Reservation. <Worker>worker is a required parameter.");
              if (!(r instanceof fe)) throw new TypeError("Failed to instantiate Reservation. <ReservationDescriptor>descriptor is a required parameter.");
              _this25._worker = e, _this25._log = e.getLogger("Reservation-".concat(r.sid)), _this25._request = t, _this25.task = _this25._createTask(r), r.transferDescriptor && (_this25.transfer = _this25._createTransfer(r)), Object.assign(_assertThisInitialized(_this25), r), delete _this25.taskDescriptor, delete _this25.transferDescriptor;
              return _possibleConstructorReturn(_this25);
            }
            _createClass(Ee, [{
              key: "accept",
              value: function accept() {
                var _this26 = this;
                var e = this._worker.getRoutes().getRoute(A, this.sid).path,
                  t = {
                    ReservationStatus: h.M0
                  };
                return this._request.post(e, t, h.x6).then(function (e) {
                  return _this26._update(e, me);
                });
              }
            }, {
              key: "complete",
              value: function complete() {
                var _this27 = this;
                var e = this._worker.getRoutes().getRoute(A, this.sid).path,
                  t = {
                    ReservationStatus: h.in
                  };
                return this._request.post(e, t, h.x6).then(function (e) {
                  return _this27._update(e, me);
                });
              }
            }, {
              key: "reject",
              value: function reject() {
                var _this28 = this;
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var t = this._worker.getRoutes().getRoute(A, this.sid).path,
                  r = {
                    ReservationStatus: h.j3
                  };
                if (!we(e, {
                  activitySid: function activitySid(e) {
                    return s().isString(e);
                  }
                })) throw new TypeError("Failed to issue Instruction:reject on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                for (var _t8 in e) r[h.iR[_t8]] = e[_t8];
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this28._update(e, me);
                });
              }
            }, {
              key: "wrap",
              value: function wrap() {
                var _this29 = this;
                var e = this._worker.getRoutes().getRoute(A, this.sid).path,
                  t = {
                    ReservationStatus: h.hO
                  };
                return this._request.post(e, t, h.x6).then(function (e) {
                  return _this29._update(e, me);
                });
              }
            }, {
              key: "call",
              value: function call(e, t) {
                var _this30 = this;
                var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                if (!s().isString(e)) throw new TypeError("Error calling method call(). <string>from is a required parameter.");
                if (!s().isString(t)) throw new TypeError("Error calling method call(). <string>url is a required parameter.");
                var i = this._worker.getRoutes().getRoute(A, this.sid).path,
                  n = {
                    Instruction: h.O,
                    CallFrom: e,
                    CallUrl: t
                  };
                if (!we(r, {
                  accept: function accept(e) {
                    return s().isBoolean(e);
                  },
                  record: function record(e) {
                    return s().isString(e);
                  },
                  statusCallbackUrl: function statusCallbackUrl(e) {
                    return s().isString(e);
                  },
                  timeout: function timeout(e) {
                    return s().isInteger(e);
                  },
                  to: function to(e) {
                    return s().isString(e);
                  }
                })) throw new TypeError("Failed to issue Instruction:call on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                for (var _e5 in r) n[h.xf[_e5]] = r[_e5];
                return this._request.post(i, n, h.x6).then(function (e) {
                  return _this30._update(e, me);
                });
              }
            }, {
              key: "dequeue",
              value: function dequeue() {
                var _this31 = this;
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var t = this._worker.getRoutes().getRoute(A, this.sid).path,
                  r = {
                    Instruction: h.iz
                  };
                if (!we(e, {
                  from: function from(e) {
                    return s().isString(e);
                  },
                  to: function to(e) {
                    return s().isString(e);
                  },
                  postWorkActivitySid: function postWorkActivitySid(e) {
                    return s().isString(e);
                  },
                  record: function record(e) {
                    return s().isString(e);
                  },
                  timeout: function timeout(e) {
                    return s().isInteger(e);
                  },
                  statusCallbackUrl: function statusCallbackUrl(e) {
                    return s().isString(e);
                  },
                  statusCallbackEvents: function statusCallbackEvents(e) {
                    return s().isString(e);
                  }
                })) throw new TypeError("Failed to issue Instruction:dequeue on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                for (var _t9 in e) r[h.EA[_t9]] = e[_t9];
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this31._update(e, me);
                });
              }
            }, {
              key: "redirect",
              value: function redirect(e, t) {
                var _this32 = this;
                var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                if (!s().isString(e)) throw new TypeError("Error calling method redirect(). <string>callSid is a required parameter.");
                if (!s().isString(t)) throw new TypeError("Error calling method redirect(). <string>url is a required parameter.");
                var i = this._worker.getRoutes().getRoute(A, this.sid).path,
                  n = {
                    accept: function accept(e) {
                      return s().isBoolean(e);
                    }
                  },
                  o = {
                    Instruction: h.nB,
                    RedirectCallSid: e,
                    RedirectUrl: t
                  };
                if (!we(r, n)) throw new TypeError("Failed to issue Instruction:redirect on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                for (var _e6 in r) o[h.qG[_e6]] = r[_e6];
                return this._request.post(i, o, h.x6).then(function (e) {
                  return _this32._update(e, me);
                });
              }
            }, {
              key: "conference",
              value: function conference() {
                var _this33 = this;
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!we(e, {
                  to: function to(e) {
                    return s().isString(e);
                  },
                  from: function from(e) {
                    return s().isString(e);
                  },
                  timeout: function timeout(e) {
                    return s().isInteger(e);
                  },
                  statusCallback: function statusCallback(e) {
                    return s().isString(e);
                  },
                  statusCallbackMethod: function statusCallbackMethod(e) {
                    return s().isString(e);
                  },
                  statusCallbackEvent: function statusCallbackEvent(e) {
                    return s().isString(e);
                  },
                  record: function record(e) {
                    return s().isString(e);
                  },
                  muted: function muted(e) {
                    return s().isBoolean(e);
                  },
                  beep: function beep(e) {
                    return s().isBoolean(e) || s().isString(e);
                  },
                  startConferenceOnEnter: function startConferenceOnEnter(e) {
                    return s().isBoolean(e);
                  },
                  endConferenceOnExit: function endConferenceOnExit(e) {
                    return s().isBoolean(e);
                  },
                  endConferenceOnCustomerExit: function endConferenceOnCustomerExit(e) {
                    return s().isBoolean(e);
                  },
                  waitUrl: function waitUrl(e) {
                    return s().isString(e);
                  },
                  waitMethod: function waitMethod(e) {
                    return s().isString(e);
                  },
                  earlyMedia: function earlyMedia(e) {
                    return s().isBoolean(e);
                  },
                  maxParticipants: function maxParticipants(e) {
                    return s().isInteger(e);
                  },
                  conferenceStatusCallback: function conferenceStatusCallback(e) {
                    return s().isString(e);
                  },
                  conferenceStatusCallbackMethod: function conferenceStatusCallbackMethod(e) {
                    return s().isString(e);
                  },
                  conferenceStatusCallbackEvent: function conferenceStatusCallbackEvent(e) {
                    return s().isString(e);
                  },
                  conferenceRecord: function conferenceRecord(e) {
                    return s().isBoolean(e) || s().isString(e);
                  },
                  conferenceTrim: function conferenceTrim(e) {
                    return s().isString(e);
                  },
                  recordingChannels: function recordingChannels(e) {
                    return s().isString(e);
                  },
                  recordingStatusCallback: function recordingStatusCallback(e) {
                    return s().isString(e);
                  },
                  recordingStatusCallbackMethod: function recordingStatusCallbackMethod(e) {
                    return s().isString(e);
                  },
                  conferenceRecordingStatusCallback: function conferenceRecordingStatusCallback(e) {
                    return s().isString(e);
                  },
                  conferenceRecordingStatusCallbackMethod: function conferenceRecordingStatusCallbackMethod(e) {
                    return s().isString(e);
                  },
                  region: function region(e) {
                    return s().isString(e);
                  },
                  sipAuthUsername: function sipAuthUsername(e) {
                    return s().isString(e);
                  },
                  sipAuthPassword: function sipAuthPassword(e) {
                    return s().isString(e);
                  }
                })) throw new TypeError("Failed to issue Instruction:conference on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                var t = this._worker.getRoutes().getRoute(A, this.sid).path,
                  r = {
                    Instruction: h.FB
                  };
                for (var _t10 in e) r[s().upperFirst(_t10)] = e[_t10];
                return this._request.post(t, r, h.x6).then(function () {
                  return _this33;
                });
              }
            }, {
              key: "updateParticipant",
              value: function updateParticipant(e) {
                var _this34 = this;
                if (!we(e, {
                  endConferenceOnExit: function endConferenceOnExit(e) {
                    return s().isBoolean(e);
                  },
                  mute: function mute(e) {
                    return s().isBoolean(e);
                  },
                  beepOnExit: function beepOnExit(e) {
                    return s().isBoolean(e);
                  }
                })) throw new TypeError("Failed to update Worker Participant tied to Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));
                var t = this._worker.getRoutes().getRoute($).path,
                  r = {
                    ReservationSid: this.sid
                  };
                for (var _t11 in e) r[s().upperFirst(_t11)] = e[_t11];
                return this._request.post(t, r, h.F3).then(function () {
                  return _this34;
                });
              }
            }, {
              key: "_createTask",
              value: function _createTask(e) {
                if (!(e instanceof fe)) return this._log.error("Error calling method _createTask() for Reservation                              sid=".concat(this.sid, ". <ReservationDescriptor>reservationDescriptor                              is a required parameter.")), {};
                var t = e.taskDescriptor;
                try {
                  return new _e(this._worker, this._request, e.sid, t);
                } catch (e) {
                  return this._log.error("Failed to create a Task for Reservation sid=".concat(this.sid, ". Error: ").concat(e)), {};
                }
              }
            }, {
              key: "_createTransfer",
              value: function _createTransfer(e) {
                if (!(e instanceof fe)) return this._log.error("Error calling method _createTransfer() for Reservation                              sid=".concat(this.sid, ". <ReservationDescriptor>reservationDescriptor                              is a required parameter.")), {};
                var t = e.transferDescriptor;
                try {
                  return new de(this._worker, t);
                } catch (e) {
                  return this._log.error("Failed to create a Transfer for Reservation sid=".concat(this.sid, ". Error: ").concat(e)), {};
                }
              }
            }, {
              key: "_update",
              value: function _update(e) {
                var _this35 = this;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                try {
                  var _r6 = new fe(e, this._worker, t);
                  ve.forEach(function (i) {
                    if ("task" === i) {
                      if (-1 === t.indexOf("task")) {
                        var _t12 = e.task_transfer,
                          _r7 = e.active_outgoing_task_transfer;
                        _this35.task._update(e.task, {
                          incoming: _t12,
                          outgoing: _r7
                        });
                      }
                    } else "canceledReasonCode" === i ? -1 === t.indexOf("canceled_reason_code") && e.canceled_reason_code && (_this35[i] = _r6[i]) : "task_transfer" === i && e.task_transfer ? _this35.transfer._update(e.task_transfer) : _this35[i] = _r6[i];
                  });
                } catch (t) {
                  throw this._log.error("Failed to update Reservation sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, ".")), t;
                }
                return this;
              }
            }, {
              key: "_emitEvent",
              value: function _emitEvent(e, t) {
                if (!s().isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
                if (!s().isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>rawEventData is a required parameter.");
                this._update(t), this.emit(e, this);
              }
            }]);
            return Ee;
          }(l.EventEmitter);
          var Se = ["account_sid", "date_created", "date_updated", "reservation_status", "sid", "task", "reservation_timeout", "worker_sid", "workspace_sid"],
            ye = Ee;
          var Te = /*#__PURE__*/function (_l$EventEmitter7) {
            _inherits(Te, _l$EventEmitter7);
            var _super9 = _createSuper(Te);
            function Te(e, t) {
              var _this36;
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _classCallCheck(this, Te);
              if (_this36 = _super9.call(this), !(e instanceof qe)) throw new TypeError("Failed to initialize ReservationsEntity. <Worker>worker is a required parameter.");
              _this36._worker = e, _this36._log = e.getLogger("ReservationsEntity"), _this36._request = t, _this36._reservations = new Map(), _this36._reservationSidsByTask = new Map(), _this36._pageSize = r.pageSize || h.L8, s().inRange(_this36._pageSize, 1, h.L8 + 1) || (_this36._log.warn("PageSize range for ReservationsEntity must be between 1 and %d. Setting pageSize to default size=%d", h.L8, h.L8), _this36._pageSize = 1e3);
              return _possibleConstructorReturn(_this36);
            }
            _createClass(Te, [{
              key: "reservations",
              get: function get() {
                return new Map(Array.from(this._reservations).filter(function (e) {
                  return !e[1][1];
                }).map(function (e) {
                  return [e[0], e[1][0]];
                }));
              }
            }, {
              key: "fetchReservations",
              value: function fetchReservations() {
                var e = this._getPage();
                return this._reservations.clear(), this._getAllReservations(e);
              }
            }, {
              key: "_getAllReservations",
              value: function _getAllReservations(e) {
                var _this37 = this;
                return e.then(function (e) {
                  e.items.forEach(function (e) {
                    _this37._insertReservation(e);
                  }), e.hasNextPage && _this37._getAllReservations(e.nextPage());
                });
              }
            }, {
              key: "_getPage",
              value: function _getPage(e) {
                var _this38 = this;
                e = e || {};
                var t = this._worker.getRoutes().getRoute(R).path,
                  r = {
                    Active: "true",
                    PageSize: this._pageSize
                  };
                return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, h.F3, r).then(function (e) {
                  return new J.default(e.contents.map(function (e) {
                    return new fe(e, _this38._worker);
                  }), function (e) {
                    return _this38._getPage({
                      AfterSid: e
                    });
                  }, e.after_sid);
                });
              }
            }, {
              key: "_insertReservation",
              value: function _insertReservation(e) {
                var t = e.sid;
                this._log.trace("_insertReservation(sid=%s, data=%s)", t, JSON.stringify(e)), this._reservations.has(t) && this._log.debug("Reservation %s already exists for Worker %s. Attempting to overwrite it.", t, this._worker.sid);
                try {
                  var _r8 = new ye(this._worker, this._request, e);
                  return this._reservations.set(t, [_r8, !1]), this._reservationSidsByTask.has(_r8.task.sid) ? this._reservationSidsByTask.get(_r8.task.sid).add(_r8.sid) : this._reservationSidsByTask.set(_r8.task.sid, new Set([_r8.sid])), this._log.debug("Successfully created and inserted %s for %s to Task-Reservation lookup. Contents: %s", _r8.sid, _r8.task.sid, this._reservationSidsByTask.get(_r8.task.sid)), _r8;
                } catch (e) {
                  throw this._log.error("Unable to create a Reservation for sid=%s. Skipping insert into Reservations map. Error: %s", t, e), e;
                }
              }
            }, {
              key: "insert",
              value: function insert(e) {
                this._log.trace("_insertReservation(sid=%s, data=%s)", e.sid, JSON.stringify(e));
                var t = new fe(e, this._worker);
                return this._insertReservation(t);
              }
            }, {
              key: "getTasks",
              value: function getTasks(e) {
                var _this39 = this;
                if (!this._reservationSidsByTask.has(e)) return null;
                var t = this._reservationSidsByTask.get(e),
                  r = [];
                return t.forEach(function (e) {
                  var t = _this39._reservations.get(e);
                  t && t[0].task && r.push(t[0].task);
                }), r;
              }
            }, {
              key: "_deleteByReservationSid",
              value: function _deleteByReservationSid(e) {
                this._log.trace("_deleteByReservationSid(sid=%s)", e);
                var t = this.reservations.get(e);
                t ? (this._log.info("Found Reservation sid=%s for Worker %s. Removing reservation and task.", e, this._worker.sid), this._cleanUpReservationAndTask(t)) : this._log.info("Reservation with sid=%s not found. Unable to remove Reservation.", e);
              }
            }, {
              key: "_cleanUpReservationAndTask",
              value: function _cleanUpReservationAndTask(e) {
                var _this40 = this;
                this._log.debug("Soft deleting Reservation sid=%s for Worker %s", e.sid, this._worker.sid), this._reservations.set(e.sid, [e, !0]), setTimeout(function () {
                  _this40._log.debug("Hard deleting of Reservation sid=%s for Worker %s", e.sid, _this40._worker.sid), _this40._reservations.delete(e.sid) || _this40._log.warn("Failed to hard delete Reservation sid=%s for Worker %s", e.sid, _this40._worker.sid);
                }, 5e3);
              }
            }]);
            return Te;
          }(l.EventEmitter);
          var be = /*#__PURE__*/function () {
            function be(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck(this, be);
              this._worker = e, this._logLevel = t.logLevel || "error", this._log = new d("WorkerEventHandler", this._logLevel);
            }
            _createClass(be, [{
              key: "getTREventsToHandlerMapping",
              value: function getTREventsToHandlerMapping() {
                return {
                  "worker.activity.update": "_workerActivityUpdateHandler",
                  "worker.attributes.update": "_workerAttributesUpdateHandler",
                  "worker.capacity.update": "_workerCapacityUpdateHandler",
                  "worker.channel.availability.update": "_workerChannelAvailabilityUpdateHandler",
                  "reservation.created": "_reservationCreatedHandler",
                  "reservation.failed": "_reservationFailedHandler",
                  "reservation.accepted": "_reservationUpdateHandler",
                  "reservation.wrapup": "_reservationUpdateHandler",
                  "reservation.completed": "_reservationCleanupEventsHandler",
                  "reservation.rejected": "_reservationCleanupEventsHandler",
                  "reservation.timeout": "_reservationCleanupEventsHandler",
                  "reservation.canceled": "_reservationCleanupEventsHandler",
                  "reservation.rescinded": "_reservationCleanupEventsHandler",
                  "task.updated": "_taskTypeEventHandler",
                  "task.canceled": "_taskTypeEventHandler",
                  "task.completed": "_taskTypeEventHandler",
                  "task.wrapup": "_taskTypeEventHandler",
                  "task.transfer-attempt-failed": "_transferTaskEventHandler",
                  "task.transfer-completed": "_transferTaskEventHandler",
                  "task.transfer-failed": "_transferTaskEventHandler",
                  "task.transfer-initiated": "_transferTaskEventHandler",
                  "task.transfer-canceled": "_transferTaskEventHandler"
                };
              }
            }, {
              key: "_workerActivityUpdateHandler",
              value: function _workerActivityUpdateHandler(e) {
                if (this._log.info("Worker %s received Event: worker.activity.update. Proceeding to update ...", this._worker.sid), !e.activity_sid) throw this._log.error("Event: worker.activity.update did not contain an activity_sid. Unable to update Worker %s.", this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " activity."));
                {
                  var _t13 = this._worker.activities.get(e.activity_sid);
                  if (!_t13) throw this._log.error("The Activity sid=%s specified in Event: worker.activity.update does not exist in the Worker's map of Activities. Unable to update Worker %s activity.", e.activity_sid, this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " activity."));
                  this._worker.activity._isCurrent = !1, this._worker.activity = _t13, _t13._isCurrent = !0, this._worker.emit("activityUpdated", this._worker._update(e));
                }
              }
            }, {
              key: "_workerAttributesUpdateHandler",
              value: function _workerAttributesUpdateHandler(e) {
                this._log.info("Worker ".concat(this._worker.sid, " received Event: worker.attributes.update. Proceeding to update ...")), this._worker.emit("attributesUpdated", this._worker._update(e));
              }
            }, {
              key: "_workerCapacityUpdateHandler",
              value: function _workerCapacityUpdateHandler(e) {
                if (this._log.info("Worker ".concat(this._worker.sid, " received Event: worker.capacity.update.")), !e.sid) throw this._log.error("Event: worker.capacity.update did not contain a Channel sid. Unable to update Channel for Worker %s.", this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " channel."));
                {
                  var _t14 = this._worker.channels.get(e.sid);
                  if (!_t14) throw this._log.error("The Channel sid=%s specified in Event: worker.capacity.update does not  exist in the Worker's map of Channels. Unable to update Worker %s channel.", e.sid, this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " channel."));
                  _t14._emitEvent("capacityUpdated", e);
                }
              }
            }, {
              key: "_workerChannelAvailabilityUpdateHandler",
              value: function _workerChannelAvailabilityUpdateHandler(e) {
                if (this._log.info("Worker %s received Event: worker.channel.availability.update.", this._worker.sid), !e.sid) throw this._log.error("Event: worker.capacity.update did not contain a Channel sid. Unable to update Channel for Worker %s.", this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " channel."));
                {
                  var _t15 = this._worker.channels.get(e.sid);
                  if (!_t15) throw this._log.error("The Channel sid=%s specified in Event: worker.channel.availability.update does not  exist in the Worker's map of Channels. Unable to update Worker %s channel.", e.sid, this._worker.sid), new Error("Failed to update Worker ".concat(this._worker.sid, " channel."));
                  _t15._emitEvent("availabilityUpdated", e);
                }
              }
            }, {
              key: "_reservationCreatedHandler",
              value: function _reservationCreatedHandler(e) {
                if (this._log.info("Worker %s received Event: reservation.created.", this._worker.sid), !e.sid) throw this._log.error("Event: reservationCreated did not contain a Reservation sid. Unable to create a Reservation for Worker %s.", this._worker.sid), new Error("Failed to create Reservation for Worker ".concat(this._worker.sid, "."));
                try {
                  this._log.info("Attempting to create and insert Reservation into Worker %s reservations map.", this._worker.sid);
                  var _t16 = this._worker._dataServices.reservationsEntity.insert(e);
                  this._worker.emit("reservationCreated", _t16);
                } catch (e) {
                  throw this._log.info("Failed to create and insert Reservation into Worker %s reservations map.", this._worker.sid), new Error("Failed to create a Reservation for Worker ".concat(this._worker.sid, " on Event: reservationCreated. Error: ").concat(e));
                }
              }
            }, {
              key: "_reservationFailedHandler",
              value: function _reservationFailedHandler(e) {
                this._log.info("Worker %s received Event: reservation.failed.", this._worker.sid), this._worker.emit("reservationFailed", e);
              }
            }, {
              key: "_reservationUpdateHandler",
              value: function _reservationUpdateHandler(e, t) {
                var r = h.zb[t];
                if (this._log.info("Worker %s received Event: %s mapped to %s.", this._worker.sid, t, r), !e.sid) throw this._log.error("Event: reservation.".concat(r, " did not contain a Reservation sid. Unable to update Reservation for Worker ").concat(this._worker.sid)), new Error("Failed to update Reservation for Worker ".concat(this._worker.sid, "."));
                {
                  var _t17 = this._worker.reservations.get(e.sid);
                  if (!_t17) throw this._log.error("The Resevation sid=".concat(e.sid, " specified in Event: reservation.").concat(r, " does not                                         exist in the Worker's map of Reservations. Unable to update Worker ").concat(this._worker.sid, " reservation.")), new Error("Failed to update Worker ".concat(this._worker.sid, " reservation."));
                  _t17._emitEvent(r, e);
                }
              }
            }, {
              key: "_reservationCleanupEventsHandler",
              value: function _reservationCleanupEventsHandler(e, t) {
                var r = h.zb[t];
                if (this._log.info("Worker %s received Event: %s mapped to %s.", this._worker.sid, t, r), !e.sid) throw this._log.error("Event: reservation.%s did not contain a Reservation sid. Unable to update Reservation for Worker %s.", r, this._worker.sid), new Error("Failed to update Reservation for Worker ".concat(this._worker.sid, "."));
                {
                  var _t18 = this._worker.reservations.get(e.sid);
                  _t18 ? (this._worker._dataServices.reservationsEntity._deleteByReservationSid(e.sid), _t18._emitEvent(r, e)) : this._log.warn("The reservation specified by Event: reservation.%s does not exist in Worker %s Reservations map. Skipping event.", r, this._worker.sid);
                }
              }
            }, {
              key: "_taskTypeEventHandler",
              value: function _taskTypeEventHandler(e, t) {
                var r = h.L3[t];
                if (this._log.info("Worker %s received Event: %s mapped to %s.", this._worker.sid, t, r), !e.sid) throw this._log.error("Event: task.%s did not contain a Task sid. Unable to emit event for Worker %s.", r, this._worker.sid), new Error("Failed to emit event for Worker ".concat(this._worker.sid, "."));
                {
                  var _t19 = this._worker._dataServices.reservationsEntity.getTasks(e.sid);
                  _t19 && _t19.length > 0 ? _t19.forEach(function (t) {
                    t._update(e), t._emitEvent(r, e);
                  }) : this._log.warn("The task specified by Event: task.%s does not exist in Worker %s Reservations map. Skipping event.", r, this._worker.sid);
                }
              }
            }, {
              key: "_transferTaskEventHandler",
              value: function _transferTaskEventHandler(e, t) {
                var r = h.l4[t];
                if (this._log.info("Worker %s received Event: % mapped to %s.", this._worker.sid, t, r), !e.initiating_reservation_sid || !e.task_sid) throw this._log.error("Event: task.%s did not contain a Reservation sid or Task sid. Unable to emit event for Worker %s.", r, this._worker.sid), new Error("Failed to emit event for Worker ".concat(this._worker.sid, "."));
                {
                  var _t20 = this._worker.reservations.get(e.initiating_reservation_sid);
                  _t20 ? _t20.task.sid === e.task_sid ? _t20.task._emitEventForOutgoingTransfer(r, e) : this._log.warn("The task %s related to Event: task.%s does not match the expected owning Reservation %s for Worker %s. Skipping event.", e.task_sid, r, _t20.sid, this._worker.sid) : this._log.warn("The reservation %s related to Event: task.%s does not exist in Worker %s Reservations map. Skipping event.", e.initiating_reservation_sid, r, this._worker.sid);
                }
              }
            }]);
            return be;
          }();
          var Re = ["dateUpdated", "dateStatusChanged", "attributes", "name", "available"];
          var Ae = /*#__PURE__*/function (_l$EventEmitter8) {
            _inherits(Ae, _l$EventEmitter8);
            var _super10 = _createSuper(Ae);
            function Ae(e) {
              var _this41;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                Request: S,
                EventBridgeSignaling: f
              };
              _classCallCheck(this, Ae);
              if (_this41 = _super10.call(this), !s().isString(e)) throw new TypeError("Failed to instantiate Worker. <string>token is a required parameter.");
              var i = {
                connectActivitySid: function connectActivitySid(e) {
                  return s().isString(e);
                },
                closeExistingSessions: function closeExistingSessions(e) {
                  return s().isBoolean(e);
                },
                logLevel: function logLevel(e) {
                  return s().isString(e);
                },
                ebServer: function ebServer(e) {
                  return s().isString(e);
                },
                wsServer: function wsServer(e) {
                  return s().isString(e);
                },
                region: function region(e) {
                  return s().isString(e);
                }
              };
              var n;
              (0, H.n)(t, i), _this41._connectActivitySid = t.connectActivitySid, _this41._closeExistingSessions = t.closeExistingSessions, _this41._logLevel = t.logLevel || "error", _this41._config = new c(e, t), _this41._log = new d("Worker-".concat(_this41._config.getLogIdentifier()), _this41._logLevel), _this41._request = new r.Request(_this41._config), _this41._dataServices = {
                activitiesEntity: new K(_assertThisInitialized(_this41), _this41._request),
                channelsEntity: new re(_assertThisInitialized(_this41), _this41._request),
                reservationsEntity: new Te(_assertThisInitialized(_this41), _this41._request)
              }, _this41._signaling = new r.EventBridgeSignaling(_assertThisInitialized(_this41), {
                closeExistingSessions: t.closeExistingSessions
              }), _this41._subscribeToSignalingEvents(), n = t.eventHandlerClass ? new t.eventHandlerClass(_assertThisInitialized(_this41)) : new be(_assertThisInitialized(_this41)), _this41.taskRouterEventHandler = n;
              return _possibleConstructorReturn(_this41);
            }
            _createClass(Ae, [{
              key: "createTask",
              value: function createTask(e, t, r, i) {
                var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                if (!s().isString(e)) throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
                if (!s().isString(t)) throw new TypeError("Error calling method createTask(). <string>from is a required parameter.");
                if (!s().isString(r)) throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
                if (!s().isString(i)) throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
                var o = {
                  attributes: function attributes(e) {
                    return s().isObject(e);
                  },
                  taskChannelUniqueName: function taskChannelUniqueName(e) {
                    return s().isString(e);
                  },
                  taskChannelSid: function taskChannelSid(e) {
                    return s().isString(e);
                  }
                };
                if (!(0, H.n)(n, o)) throw new TypeError("Failed to create a Task for Worker ".concat(this.sid, ". The options passed in did not match the required types."));
                var a = this.getRoutes().getRoute(O).path,
                  d = {
                    WorkflowSid: r,
                    TaskQueueSid: i,
                    RoutingTarget: this.sid
                  };
                for (var _e7 in n) "attributes" === _e7 || (d[h.VH[_e7]] = n[_e7]);
                var c = {
                  outbound_to: e,
                  from: t
                };
                return d.Attributes = Object.assign({}, n.attributes, c), this._request.post(a, d, h.x6).then(function (e) {
                  return e.sid;
                });
              }
            }, {
              key: "getLogger",
              value: function getLogger(e) {
                return new d("".concat(e, "-").concat(this.sid), this._config._logLevel);
              }
            }, {
              key: "setAttributes",
              value: function setAttributes(e) {
                var _this42 = this;
                if (!s().isObject(e)) throw new TypeError("Unable to set attributes on Worker. <object>attributes is a required parameter.");
                var t = this.getRoutes().getRoute(W).path,
                  r = {
                    Attributes: e
                  };
                return this._request.post(t, r, h.x6).then(function (e) {
                  return _this42._update(e);
                });
              }
            }, {
              key: "updateToken",
              value: function updateToken(e) {
                if (!s().isString(e)) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
                this._log.info("Proceeding to update the Worker's current active token with a new token."), this._log.debug("New token: " + e);
                try {
                  this._config.updateToken(e), this._signaling.updateToken(e), this.emit("tokenUpdated");
                } catch (e) {
                  this.emit("error", e);
                }
              }
            }, {
              key: "_subscribeToSignalingEvents",
              value: function _subscribeToSignalingEvents() {
                var _this43 = this;
                this._log.info("Subscribing to Signaling events .... "), this._signaling.on("connected", function () {
                  _this43._log.info("Received Event: 'connected' from Signaling layer. Pending initialization.", _this43.sid);
                }), this._signaling.on("disconnected", function (e) {
                  _this43._log.info("Received Event: 'disconnected' from Signaling layer for Worker %s. %s", _this43.sid, e), _this43._unSubscribeFromTaskRouterEvents(), _this43.emit("disconnected", e);
                }), this._signaling.on("init", function (e) {
                  _this43._log.info("Received Event: 'init' from Signaling layer. Proceeding to initialize Worker %s.", e.channel_id), _this43.sid = e.channel_id, _this43.accountSid = e.account_sid, _this43.workspaceSid = e.workspace_sid, _this43._signaling.setLifetime(e.token_lifetime), _this43._initialize();
                }), this._signaling.on("error", function (e) {
                  _this43._log.info("Received Event: 'error' from Signaling layer for Worker %s.", _this43.sid), _this43.emit("error", e);
                }), this._signaling.on("tokenExpired", function () {
                  _this43._log.info("Received Event: 'tokenExpired' for for Worker %s. Please update the token. Websocket will not reconnect automatically until token is updated.", _this43.sid), _this43.emit("tokenExpired");
                });
              }
            }, {
              key: "_subscribeToTaskRouterEvents",
              value: function _subscribeToTaskRouterEvents() {
                this._log.info("Subscribing to TaskRouter events ... ");
                for (var _i = 0, _Object$entries = Object.entries(this.taskRouterEventHandler.getTREventsToHandlerMapping()); _i < _Object$entries.length; _i++) {
                  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                    _e8 = _Object$entries$_i[0],
                    _t21 = _Object$entries$_i[1];
                  this._signaling.on(_e8, this.taskRouterEventHandler[_t21]);
                }
              }
            }, {
              key: "_unSubscribeFromTaskRouterEvents",
              value: function _unSubscribeFromTaskRouterEvents() {
                this._log.info("Unsubscribing from TaskRouter events ... ");
                for (var _i2 = 0, _Object$entries2 = Object.entries(this.taskRouterEventHandler.getTREventsToHandlerMapping()); _i2 < _Object$entries2.length; _i2++) {
                  var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                    _e9 = _Object$entries2$_i[0],
                    _t22 = _Object$entries2$_i[1];
                  this._signaling.removeListener(_e9, this.taskRouterEventHandler[_t22]);
                }
              }
            }, {
              key: "_initialize",
              value: function _initialize() {
                var _this44 = this;
                this._routes = new z(this.workspaceSid, this.sid), this._log.info("Initializing Worker %s...", this.sid);
                var e = this.getRoutes().getRoute(W).path;
                var t;
                this._request.get(e, h.x6).then(function (e) {
                  var r = new M(e, _this44._config);
                  return t = r.activitySid, delete r.activityName, delete r.activitySid, delete r.available, Object.assign(_this44, r), Promise.all([_this44._dataServices.activitiesEntity.fetchActivities(), _this44._dataServices.channelsEntity.fetchChannels(), _this44._dataServices.reservationsEntity.fetchReservations()]);
                }).then(function () {
                  _this44._log.info("Worker %s activities, channels and pending reservations initialized", _this44.sid), _this44._setCurrentActivity(t), _this44._connectActivitySid ? _this44._setWorkerConnectActivity().then(function () {
                    _this44._log.info("Successfully updated Worker on connect to Activity=%s", _this44._connectActivitySid), _this44._log.info("Worker %s successfully initialized", _this44.sid);
                  }) : _this44._log.info("Worker %s successfully initialized", _this44.sid), _this44._subscribeToTaskRouterEvents(), _this44.emit("ready", _this44);
                }).catch(function (e) {
                  _this44._log.error("Failed to initialize Worker %s. Error: %s", _this44.sid, e), _this44.emit("error", "Failed to initialize Worker ".concat(_this44.sid));
                });
              }
            }, {
              key: "channels",
              get: function get() {
                return this._dataServices.channelsEntity.channels;
              }
            }, {
              key: "activities",
              get: function get() {
                return this._dataServices.activitiesEntity.activities;
              }
            }, {
              key: "reservations",
              get: function get() {
                return this._dataServices.reservationsEntity.reservations;
              }
            }, {
              key: "_setCurrentActivity",
              value: function _setCurrentActivity(e) {
                var t = this.activities.get(e);
                if (!t) throw new Error("Unable to set the current Activity sid=".concat(e, " on the Worker."));
                t._isCurrent = !0, this.activity = t, this.activity._isCurrent = !0;
              }
            }, {
              key: "_setWorkerConnectActivity",
              value: function _setWorkerConnectActivity() {
                var _this45 = this;
                if (!s().isString(this._connectActivitySid)) throw new TypeError("Failed to set the Worker's activity to the provided optional connectActivitySid. <string>connectActivitySid must be a string.");
                return this._updateWorkerActivity(this._connectActivitySid).then(function () {
                  return _this45._log.info("Successfully set the Worker's activity to the provided connectActivitySid=%s on connection.", _this45._connectActivitySid), _this45._connectRetry = 0, _this45;
                }).catch(function (e) {
                  if (_this45._connectRetry >= 3) throw _this45._log.error("Unable to set Worker %s activity to the provided %s on successful connection. %s", _this45.sid, _this45._connectActivitySid, e), e;
                  return _this45._connectRetry = _this45._connectRetry > 0 ? _this45._connectRetry + 1 : 1, new Promise(function (e) {
                    return setTimeout(e, 500);
                  }).then(_this45._setWorkerConnectActivity.bind(_this45));
                });
              }
            }, {
              key: "_updateWorkerActivity",
              value: function _updateWorkerActivity(e) {
                var _this46 = this;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!s().isString(e)) throw new TypeError("Error updating Worker Activity: <string>activitySid is a required parameter");
                var r = this.getRoutes().getRoute(W).path,
                  i = {
                    ActivitySid: e
                  };
                for (var _e10 in t) i[h.UA[_e10]] = t[_e10];
                return this._request.post(r, i, h.x6).then(function (t) {
                  try {
                    _this46._update(t), _this46.activity._isCurrent = !1;
                    var _e11 = _this46.activities.get(t.activity_sid);
                    _this46.activity = _e11, _this46.activity._isCurrent = !0;
                  } catch (t) {
                    throw _this46._log.error("Failed to update the Worker's activity to sid=%s. Error: %s", e, t), t;
                  }
                  return _this46;
                });
              }
            }, {
              key: "_update",
              value: function _update(e) {
                var _this47 = this;
                this._log.trace("Attempting to update Worker %s with latest Worker data=%s", this.sid, JSON.stringify(e));
                try {
                  var _t23 = new M(e, this._config);
                  Re.forEach(function (e) {
                    _this47[e] = _t23[e];
                  });
                } catch (t) {
                  this._log.error("Failed to update Worker sid=%s. Update aborted. Error: %s.", e.sid, t);
                }
                return this;
              }
            }, {
              key: "disconnect",
              value: function disconnect() {
                this._signaling.disconnect();
              }
            }, {
              key: "getRoutes",
              value: function getRoutes() {
                return this._routes;
              }
            }]);
            return Ae;
          }(l.EventEmitter);
          var We = ["account_sid", "activity_name", "activity_sid", "attributes", "available", "date_created", "date_status_changed", "date_updated", "friendly_name", "sid", "workspace_sid"],
            qe = Ae;
          var Ce = /*#__PURE__*/function (_qe) {
            _inherits(Ce, _qe);
            var _super11 = _createSuper(Ce);
            function Ce() {
              _classCallCheck(this, Ce);
              return _super11.apply(this, arguments);
            }
            _createClass(Ce, [{
              key: "monitor",
              value: function monitor(e, t, r) {
                if (!s().isString(e)) throw new TypeError("Error monitoring reservation: <string>taskSid is a required parameter");
                if (!s().isString(t)) throw new TypeError("Error monitoring reservation: <string>reservationSid is a required parameter");
                if (r && !s().isObject(r)) throw new TypeError("Error monitoring reservation: <string>extraParams must be an object");
                return this._supervise("monitor", e, t, r);
              }
            }, {
              key: "_supervise",
              value: function _supervise(e, t, r, i) {
                var s = this.getRoutes().getRoute(C, t, r).path,
                  n = Object.assign({}, i, {
                    Instruction: "supervise",
                    Supervisor: this.sid,
                    SupervisorMode: e
                  });
                return this._request.post(s, n, h.x6).then(function () {});
              }
            }]);
            return Ce;
          }(qe);
          var Oe = /*#__PURE__*/_createClass(function Oe(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Oe);
            if ((this instanceof Oe ? this.constructor : void 0) === Oe) throw new TypeError("You cannot instantiate TaskRouterBase directly");
            this._config = new c(e, t), this._request = new S(this._config), this.jwt = e, this.accountSid = e.sub, this.workspaceSid = e.grants.task_router.workspace_sid, this.workerSid = e.grants.task_router.worker_sid, this.role = e.grants.task_router.role;
          });
          var xe = ["friendly_name", "reservation_activity_name", "assignment_activity_name", "target_workers", "max_reserved_workers", "task_order", "reservation_activity_sid", "assignment_activity_sid", "workspace_sid", "account_sid", "sid", "date_created", "date_updated", "lifo_queue"],
            Fe = /*#__PURE__*/_createClass(function Fe(e) {
              _classCallCheck(this, Fe);
              if (!(e instanceof je)) throw new TypeError("Failed to create a TaskQueue. <TaskQueueDescriptor>descriptor is a required parameter.");
              Object.assign(this, e);
            });
          var je = /*#__PURE__*/_createClass(function je(e) {
            _classCallCheck(this, je);
            if (!s().isObject(e)) throw new TypeError("Failed to instantiate TaskQueueDescriptor. <Descriptor>descriptor is required.");
            if (!xe.every(function (t) {
              return t in e;
            })) throw new TypeError("Failed to instantiate TaskQueueDescriptor. <Descriptor>descriptor does not contain all properties of a TaskQueue.");
            this.sid = e.sid, this.accountSid = e.account_sid, this.workspaceSid = e.workspace_sid, this.name = e.friendly_name, this.assignmentActivityName = e.assignment_activity_name, this.reservationActivityName = e.reservation_activity_name, this.assignmentActivitySid = e.assignment_activity_sid, this.reservationActivitySid = e.reservation_activity_sid, this.targetWorkers = e.target_workers, this.maxReservedWorkers = e.max_reserved_workers, this.taskOrder = e.task_order, this.dateCreated = (0, H.T)(1e3 * e.date_created), this.dateUpdated = (0, H.T)(1e3 * e.date_updated);
          });
          var De = /*#__PURE__*/_createClass(function De(e) {
              _classCallCheck(this, De);
              if (!(e instanceof M)) throw new TypeError("Failed to create a WorkerContainer. <WorkerDescriptor>descriptor is a required parameter.");
              Object.assign(this, e);
            }),
            Ue = r(442);
          var Pe = /*#__PURE__*/function () {
            function Pe(e, t) {
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _classCallCheck(this, Pe);
              if (!(e instanceof qe)) throw new TypeError("Failed to initialize WorkspacesEntity. <Worker>worker is a required parameter.");
              this._Workers = new Map(), this._TaskQueues = new Map(), this._worker = e, this._request = t, this._log = e.getLogger("WorkspaceEntity-".concat(this._worker.workspaceSid)), this._pageSize = r.pageSize || h.L8, s().inRange(this._pageSize, 1, h.L8 + 1) || (this._log.warn("PageSize range for WorkspaceEntity must be between 1 and %d. Setting pageSize to default size=%d", h.L8, h.L8), this._pageSize = h.L8);
            }
            _createClass(Pe, [{
              key: "Workers",
              get: function get() {
                return this._Workers;
              }
            }, {
              key: "TaskQueues",
              get: function get() {
                return this._TaskQueues;
              }
            }, {
              key: "fetchWorkers",
              value: function fetchWorkers() {
                return this._getAllWorkers(this._getWorkerPage());
              }
            }, {
              key: "fetchTaskQueues",
              value: function fetchTaskQueues() {
                return this._getAllTaskQueues(this._getTaskQueuePage());
              }
            }, {
              key: "_getAllWorkers",
              value: function _getAllWorkers(e) {
                var _this48 = this;
                return e.then(function (e) {
                  e.items.forEach(function (e) {
                    return _this48._insertWorker(e);
                  }), e.hasNextPage && _this48._getAllWorkers(e.nextPage());
                });
              }
            }, {
              key: "_getWorkerPage",
              value: function _getWorkerPage(e) {
                var _this49 = this;
                e = e || {};
                var t = this._worker.getRoutes().getRoute(q).path,
                  r = {
                    PageSize: this._pageSize
                  };
                return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, h.x6, r).then(function (e) {
                  return new Ue(e.contents.map(function (e) {
                    return new M(e);
                  }), function (e) {
                    return _this49._getPage({
                      AfterSid: e
                    });
                  }, e.after_sid);
                });
              }
            }, {
              key: "_insertWorker",
              value: function _insertWorker(e) {
                var t = e.sid;
                this._log.trace("_insertWorker(sid=%s, data=%s)", t, JSON.stringify(e));
                try {
                  this._Workers.set(t, new De(e));
                } catch (e) {
                  this._log.error("Unable to create a Worker for sid=%s. Skipping insert into Worker map. Error: %s", t, e);
                }
              }
            }, {
              key: "_getAllTaskQueues",
              value: function _getAllTaskQueues(e) {
                var _this50 = this;
                return e.then(function (e) {
                  e.items.forEach(function (e) {
                    return _this50._insertTaskQueue(e);
                  }), e.hasNextPage && _this50._getAllTaskQueues(e.nextPage());
                });
              }
            }, {
              key: "_getTaskQueuePage",
              value: function _getTaskQueuePage(e) {
                var _this51 = this;
                e = e || {};
                var t = this._worker.getRoute(D).path,
                  r = {
                    PageSize: this._pageSize
                  };
                return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, h.x6, r).then(function (e) {
                  return new Ue(e.contents.map(function (e) {
                    return new je(e);
                  }), function (e) {
                    return _this51._getPage({
                      AfterSid: e
                    });
                  }, e.after_sid);
                });
              }
            }, {
              key: "_insertTaskQueue",
              value: function _insertTaskQueue(e) {
                var t = e.sid;
                this._log.trace("_insertTaskQueue(sid=%s, data=%s", t, JSON.stringify(e));
                try {
                  this._TaskQueues.set(t, new Fe(e));
                } catch (e) {
                  this._log.error("Unable to create a TaskQueue for sid=%s. Skipping insert into TaskQueue map. Error: %s", t, e);
                }
              }
            }]);
            return Pe;
          }();
          var Ne = /*#__PURE__*/function (_Oe) {
            _inherits(Ne, _Oe);
            var _super12 = _createSuper(Ne);
            function Ne(e) {
              var _this52;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              _classCallCheck(this, Ne);
              if (_this52 = _super12.call(this, e, t), "admin" !== _this52.role.toLowerCase()) throw new TypeError('A token with the "admin" role is required to use this functionality.');
              _this52.workspaceEntity = new Pe(_this52._config, _this52._request, t);
              return _possibleConstructorReturn(_this52);
            }
            _createClass(Ne, [{
              key: "fetchWorkers",
              value: function fetchWorkers() {
                var _this53 = this;
                return this.workspaceEntity.fetchWorkers().then(function () {
                  return _this53.workspaceEntity.Workers;
                });
              }
            }, {
              key: "fetchTaskQueues",
              value: function fetchTaskQueues() {
                var _this54 = this;
                return this.workspaceEntity.fetchTaskQueues().then(function () {
                  return _this54.workspaceEntity.TaskQueues;
                });
              }
            }]);
            return Ne;
          }(Oe);
        },
        470: function _(e) {
          "use strict";

          function t(e) {
            if ("string" != typeof e) throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
          }
          function r(e, t) {
            for (var r, i = "", s = 0, n = -1, o = 0, a = 0; a <= e.length; ++a) {
              if (a < e.length) r = e.charCodeAt(a);else {
                if (47 === r) break;
                r = 47;
              }
              if (47 === r) {
                if (n === a - 1 || 1 === o) ;else if (n !== a - 1 && 2 === o) {
                  if (i.length < 2 || 2 !== s || 46 !== i.charCodeAt(i.length - 1) || 46 !== i.charCodeAt(i.length - 2)) if (i.length > 2) {
                    var d = i.lastIndexOf("/");
                    if (d !== i.length - 1) {
                      -1 === d ? (i = "", s = 0) : s = (i = i.slice(0, d)).length - 1 - i.lastIndexOf("/"), n = a, o = 0;
                      continue;
                    }
                  } else if (2 === i.length || 1 === i.length) {
                    i = "", s = 0, n = a, o = 0;
                    continue;
                  }
                  t && (i.length > 0 ? i += "/.." : i = "..", s = 2);
                } else i.length > 0 ? i += "/" + e.slice(n + 1, a) : i = e.slice(n + 1, a), s = a - n - 1;
                n = a, o = 0;
              } else 46 === r && -1 !== o ? ++o : o = -1;
            }
            return i;
          }
          var i = {
            resolve: function resolve() {
              for (var e, i = "", s = !1, n = arguments.length - 1; n >= -1 && !s; n--) {
                var o;
                n >= 0 ? o = arguments[n] : (void 0 === e && (e = process.cwd()), o = e), t(o), 0 !== o.length && (i = o + "/" + i, s = 47 === o.charCodeAt(0));
              }
              return i = r(i, !s), s ? i.length > 0 ? "/" + i : "/" : i.length > 0 ? i : ".";
            },
            normalize: function normalize(e) {
              if (t(e), 0 === e.length) return ".";
              var i = 47 === e.charCodeAt(0),
                s = 47 === e.charCodeAt(e.length - 1);
              return 0 !== (e = r(e, !i)).length || i || (e = "."), e.length > 0 && s && (e += "/"), i ? "/" + e : e;
            },
            isAbsolute: function isAbsolute(e) {
              return t(e), e.length > 0 && 47 === e.charCodeAt(0);
            },
            join: function join() {
              if (0 === arguments.length) return ".";
              for (var e, r = 0; r < arguments.length; ++r) {
                var s = arguments[r];
                t(s), s.length > 0 && (void 0 === e ? e = s : e += "/" + s);
              }
              return void 0 === e ? "." : i.normalize(e);
            },
            relative: function relative(e, r) {
              if (t(e), t(r), e === r) return "";
              if ((e = i.resolve(e)) === (r = i.resolve(r))) return "";
              for (var s = 1; s < e.length && 47 === e.charCodeAt(s); ++s);
              for (var n = e.length, o = n - s, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a);
              for (var d = r.length - a, c = o < d ? o : d, h = -1, l = 0; l <= c; ++l) {
                if (l === c) {
                  if (d > c) {
                    if (47 === r.charCodeAt(a + l)) return r.slice(a + l + 1);
                    if (0 === l) return r.slice(a + l);
                  } else o > c && (47 === e.charCodeAt(s + l) ? h = l : 0 === l && (h = 0));
                  break;
                }
                var u = e.charCodeAt(s + l);
                if (u !== r.charCodeAt(a + l)) break;
                47 === u && (h = l);
              }
              var p = "";
              for (l = s + h + 1; l <= n; ++l) l !== n && 47 !== e.charCodeAt(l) || (0 === p.length ? p += ".." : p += "/..");
              return p.length > 0 ? p + r.slice(a + h) : (a += h, 47 === r.charCodeAt(a) && ++a, r.slice(a));
            },
            _makeLong: function _makeLong(e) {
              return e;
            },
            dirname: function dirname(e) {
              if (t(e), 0 === e.length) return ".";
              for (var r = e.charCodeAt(0), i = 47 === r, s = -1, n = !0, o = e.length - 1; o >= 1; --o) if (47 === (r = e.charCodeAt(o))) {
                if (!n) {
                  s = o;
                  break;
                }
              } else n = !1;
              return -1 === s ? i ? "/" : "." : i && 1 === s ? "//" : e.slice(0, s);
            },
            basename: function basename(e, r) {
              if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
              t(e);
              var i,
                s = 0,
                n = -1,
                o = !0;
              if (void 0 !== r && r.length > 0 && r.length <= e.length) {
                if (r.length === e.length && r === e) return "";
                var a = r.length - 1,
                  d = -1;
                for (i = e.length - 1; i >= 0; --i) {
                  var c = e.charCodeAt(i);
                  if (47 === c) {
                    if (!o) {
                      s = i + 1;
                      break;
                    }
                  } else -1 === d && (o = !1, d = i + 1), a >= 0 && (c === r.charCodeAt(a) ? -1 == --a && (n = i) : (a = -1, n = d));
                }
                return s === n ? n = d : -1 === n && (n = e.length), e.slice(s, n);
              }
              for (i = e.length - 1; i >= 0; --i) if (47 === e.charCodeAt(i)) {
                if (!o) {
                  s = i + 1;
                  break;
                }
              } else -1 === n && (o = !1, n = i + 1);
              return -1 === n ? "" : e.slice(s, n);
            },
            extname: function extname(e) {
              t(e);
              for (var r = -1, i = 0, s = -1, n = !0, o = 0, a = e.length - 1; a >= 0; --a) {
                var d = e.charCodeAt(a);
                if (47 !== d) -1 === s && (n = !1, s = a + 1), 46 === d ? -1 === r ? r = a : 1 !== o && (o = 1) : -1 !== r && (o = -1);else if (!n) {
                  i = a + 1;
                  break;
                }
              }
              return -1 === r || -1 === s || 0 === o || 1 === o && r === s - 1 && r === i + 1 ? "" : e.slice(r, s);
            },
            format: function format(e) {
              if (null === e || "object" != typeof e) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
              return function (e, t) {
                var r = t.dir || t.root,
                  i = t.base || (t.name || "") + (t.ext || "");
                return r ? r === t.root ? r + i : r + e + i : i;
              }("/", e);
            },
            parse: function parse(e) {
              t(e);
              var r = {
                root: "",
                dir: "",
                base: "",
                ext: "",
                name: ""
              };
              if (0 === e.length) return r;
              var i,
                s = e.charCodeAt(0),
                n = 47 === s;
              n ? (r.root = "/", i = 1) : i = 0;
              for (var o = -1, a = 0, d = -1, c = !0, h = e.length - 1, l = 0; h >= i; --h) if (47 !== (s = e.charCodeAt(h))) -1 === d && (c = !1, d = h + 1), 46 === s ? -1 === o ? o = h : 1 !== l && (l = 1) : -1 !== o && (l = -1);else if (!c) {
                a = h + 1;
                break;
              }
              return -1 === o || -1 === d || 0 === l || 1 === l && o === d - 1 && o === a + 1 ? -1 !== d && (r.base = r.name = 0 === a && n ? e.slice(1, d) : e.slice(a, d)) : (0 === a && n ? (r.name = e.slice(1, o), r.base = e.slice(1, d)) : (r.name = e.slice(a, o), r.base = e.slice(a, d)), r.ext = e.slice(o, d)), a > 0 ? r.dir = e.slice(0, a - 1) : n && (r.dir = "/"), r;
            },
            sep: "/",
            delimiter: ":",
            win32: null,
            posix: null
          };
          i.posix = i, e.exports = i;
        },
        997: function _(e) {
          e.exports = {
            Agent: /*#__PURE__*/_createClass(function Agent(e) {
              "use strict";

              _classCallCheck(this, Agent);
            })
          };
        },
        622: function _(e) {
          "use strict";

          e.exports = require("loglevel");
        },
        464: function _(e) {
          "use strict";

          e.exports = require("util");
        },
        352: function _(e) {
          "use strict";

          e.exports = require("ws");
        }
      },
      t = {};
    function r(i) {
      var s = t[i];
      if (void 0 !== s) return s.exports;
      var n = t[i] = {
        exports: {}
      };
      return e[i](n, n.exports, r), n.exports;
    }
    return r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var i in t) r.o(t, i) && !r.o(e, i) && Object.defineProperty(e, i, {
        enumerable: !0,
        get: t[i]
      });
    }, r.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r(347);
  }();
});